const messages = {
  ar: {
    translations: {
      mainDrawer: {
        listItems: {
          management: "التحليلات",
          dashboard: "لوحة التحكم",
          connections: "الاتصالات",
          chatsTempoReal: "اللوحة",
          tickets: "الخدمات",
          quickMessages: "الردود السريعة",
          contacts: "جهات الاتصال",
          queues: "الصفوف",
          flowbuilder: "منشئ التدفقات",
          tags: "الوسوم",
          administration: "الإدارة",
          companies: "الشركات",
          users: "المستخدمون",
          settings: "الإعدادات",
          files: "قائمة الملفات",
          helps: "المساعدة",
          messagesAPI: "API",
          schedules: "المواعيد",
          campaigns: "الحملات",
          annoucements: "الإعلانات",
          announcements: "الإعلانات",
          knowledgeBase: "قاعدة المعرفة",
          agentQualification: "تأهيل الوكيل",
          chats: "المحادثة الداخلية",
          financeiro: "المالية",
          queueIntegration: "التكاملات",
          version: "الإصدار",
          kanban: "كانبان",
          prompts: "الموجهات",
          allConnections: "إدارة الاتصالات",
          reports: "التقارير",
        },
        appBar: {
          search: "بحث...",
          user: {
            profile: "الملف الشخصي",
            logout: "تسجيل الخروج",
            message: "مرحباً",
            messageEnd: "مرحباً بك في",
            active: "نشط حتى",
            goodMorning: "مرحباً،",
            myName: "اسمي",
            continuity: "وسأتابع خدمتك.",
            virtualAssistant: "المساعد الافتراضي",
            token: "رمز غير صالح، يرجى التواصل مع مسؤول المنصة.",
          },
          message: {
            location: "الموقع",
            contact: "جهة الاتصال",
          },
          notRegister: "لا يوجد سجل",
          refresh: "تحديث",
          themeLight: "الوضع الفاتح",
          themeDark: "الوضع الداكن",
          volume: "الصوت",
          volumeNotifications: "صوت الإشعارات",
          installPwa: {
            title: "إضافة إلى الشاشة الرئيسية",
            iosStep1: "اضغط زر المشاركة (أيقونة مربع مع سهم للأعلى)",
            iosStep2: "مرر واضغط \"إضافة إلى الشاشة الرئيسية\"",
            iosStep3: "اضغط \"إضافة\"",
            androidStep1: "اضغط قائمة المتصفح ⋮ (قائمة Chrome ذات النقاط الثلاث)",
            androidStep2: "اضغط \"إضافة إلى الشاشة الرئيسية\" أو \"تثبيت التطبيق\"",
            androidStep3: "أكد بالضغط على \"تثبيت\"",
            gotIt: "فهمت",
          },
        },
      },
      signup: {
        title: "تسجيل",
        toasts: {
          success: "تم إنشاء المستخدم بنجاح! قم بتسجيل الدخول!!!",
          fail: "خطأ في إنشاء المستخدم. تحقق من البيانات المدخلة.",
          userCreationDisabled: "تم تعطيل تسجيل المستخدمين الجدد.",
          verificationError: "خطأ في التحقق من أذونات التسجيل.",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          company: "اسم المؤسسة",
          phone: "واتساب (رمز الدولة + الرقم)",
          phonePlaceholder: "+966 50 000 0000",
          plan: "الخطة",
          planDetails: {
            attendants: "الوكلاء",
            whatsapp: "واتساب",
            queues: "الصفوف",
            currency: "ر.س",
          },
        },
        buttons: {
          submit: "تسجيل",
          login: "هل لديك حساب؟ سجل الدخول!",
        },
      },
      validation: {
        tooShort: "قصير جداً!",
        tooLong: "طويل جداً!",
        required: "مطلوب",
        invalidEmail: "بريد إلكتروني غير صحيح",
      },
      knowledgeBase: {
        datasets: {
          table: {
            mode: "الوضع",
          },
          modes: {
            ask: "سؤال",
            internal: "داخلي",
          },
        },
      },
      schedulesForm: {
        keepFlowsOutOfHours: {
          title: "إبقاء التدفقات نشطة خارج ساعات العمل",
          description: "عند التشغيل، تستمر روبوتات الدردشة وتدفقات FlowBuilder في الاستجابة حتى خارج ساعات العمل. لن يتم إرسال رسالة الغياب أدناه في هذا الوضع.",
        },
        outOfHoursMessage: {
          title: "رسالة خارج ساعات العمل",
          description: "تُرسَل تلقائياً عندما يكتب العميل خارج ساعات العمل.",
          placeholder: "مثال: مرحباً! نحن خارج ساعات العمل، سنرد عليك قريباً.",
        },
        helps: {
          keepFlowsOutOfHours: {
            description: "يحدد ما يحدث عند إرسال رسالة خارج ساعات العمل المضبوطة أدناه.",
            steps: [
              "إيقاف (افتراضي): تتوقف الروبوتات والتدفقات؛ يستلم العميل رسالة الغياب إن وُجدت.",
              "تشغيل: تستمر الروبوتات و FlowBuilder بالعمل بشكل طبيعي؛ لا تُرسل رسالة الغياب.",
              "فعّله إذا كانت تدفقاتك تعمل 24/7 (خدمة ذاتية، أسئلة شائعة، ذكاء اصطناعي).",
              "أبقه مغلقاً إذا كان التدفق يحتوي على وكلاء بشريين قد يكونون غير متصلين.",
            ],
          },
          outOfHoursMessage: {
            description: "نص يُرسل مرة واحدة لكل تذكرة عندما يكتب العميل خارج ساعات العمل.",
            steps: [
              "فعّل المفتاح واكتب الرسالة التي ستُرسَل تلقائياً.",
              "تُرسَل مرة واحدة فقط لكل تذكرة — لن يُرسَل بريد عشوائي للعميل عند إرسال عدة رسائل.",
              "تعمل مع الجدول الزمني المضبوط في \"عام › جدول ساعات العمل\".",
              "لا تُرسَل إذا كان \"إبقاء التدفقات نشطة خارج ساعات العمل\" مفعَّلاً.",
            ],
          },
        },
        bulk: {
          fillWeekdays: "أيام العمل 09:00–18:00",
          fillWeekdaysHelp: "يملأ الإثنين–الجمعة بـ 09:00–12:00 و 13:00–18:00",
          closeWeekend: "إغلاق نهاية الأسبوع",
          closeWeekendHelp: "يمسح السبت والأحد",
          copyFirst: "نسخ من اليوم الأول",
          copyFirstHelp: "يطبق ساعات الإثنين على باقي الأيام",
          clearAll: "مسح الكل",
          clearAllHelp: "يحذف جميع الساعات المضبوطة",
        },
        morning: "صباح",
        afternoon: "بعد الظهر",
        start: "البداية",
        end: "النهاية",
        dayClosed: "مغلق في هذا اليوم",
      },
      login: {
        title: "تسجيل الدخول",
        logoAlt: "الشعار",
        emailLabel: "البريد الإلكتروني",
        passwordLabel: "كلمة المرور",
        rememberMe: "تذكرني",
        loginButton: "تسجيل الدخول",
        signupButton: "سجل",
        noAccount: "ليس لديك حساب؟",
        forgotPassword: "نسيت كلمة المرور؟",
        secureArea: "منطقة آمنة",
        emailPlaceholder: "you@example.com",
        togglePassword: "إظهار/إخفاء كلمة المرور",
        or: "أو",
        whatsappLabel: "تحدث معنا على واتساب",
        whatsappTitle: "تحدث معنا على واتساب",
        form: {
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          button: "دخول",
        },
        buttons: {
          submit: "تسجيل الدخول",
          register: "ليس لديك حساب؟ سجل!",
        },
      },
      auth: {
        toasts: {
          success: "تم تسجيل الدخول بنجاح!",
        },
        dueDate: {
          expiration: "انتهاء صلاحية اشتراكك في",
          days: "أيام!",
          day: "يوم!",
          expirationToday: "ينتهي اشتراكك اليوم!",
        },
        token: "الرمز المميز",
      },
      companies: {
        title: "الشركات",
        form: {
          name: "اسم الشركة",
          plan: "الخطة",
          token: "الرمز المميز",
          submit: "تسجيل",
          success: "تم إنشاء الشركة بنجاح!",
        },
      },
      forgotPassword: {
        title: "إعادة تعيين كلمة المرور",
        form: {
          emailLabel: "أدخل بريدك الإلكتروني",
          submitButton: "إرسال رابط إعادة التعيين",
          backToLogin: "العودة لتسجيل الدخول",
        },
        loading: {
          sending: "جاري الإرسال...",
          sent: "تم الإرسال!",
        },
        toasts: {
          success: "تم إرسال رابط إعادة تعيين كلمة المرور بنجاح",
        },
      },
      resetPassword: {
        title: "إعادة تعيين كلمة المرور",
        form: {
          newPassword: "كلمة المرور الجديدة",
          confirmPassword: "تأكيد كلمة المرور",
        },
        buttons: {
          submit: "إعادة تعيين كلمة المرور",
          submitting: "جاري إعادة التعيين...",
          submitted: "تم إعادة التعيين!",
          backToLogin: "العودة لتسجيل الدخول",
        },
        errors: {
          passwordMismatch: "كلمات المرور غير متطابقة",
          passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
          invalidToken: "رمز إعادة التعيين مفقود أو غير صحيح. يرجى طلب رابط إعادة تعيين جديد.",
          resetError: "خطأ في إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.",
        },
        toasts: {
          success: "تم إعادة تعيين كلمة المرور بنجاح",
          passwordMismatch: "كلمات المرور غير متطابقة",
          passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
        },
      },
      financeiro: {
        title: "الفواتير",
        table: {
          details: "التفاصيل",
          users: "المستخدمون",
          connections: "الاتصالات",
          queues: "قوائم الانتظار",
          value: "القيمة",
          dueDate: "تاريخ الاستحقاق",
          status: "الحالة",
          action: "الإجراء"
        },
        tooltips: {
          details: "تفاصيل الفاتورة",
          users: "عدد المستخدمين",
          connections: "عدد الاتصالات",
          queues: "عدد قوائم الانتظار",
          value: "قيمة الفاتورة",
          dueDate: "تاريخ الاستحقاق"
        },
        status: {
          paid: "مدفوع",
          overdue: "منتهي الصلاحية",
          open: "مفتوح",
          yes: "نعم",
          no: "لا",
          overdueFor: "منتهي الصلاحية منذ {{days}} أيام",
          dueToday: "مستحق اليوم",
          dueIn: "مستحق خلال {{days}} أيام"
        },
        buttons: {
          pay: "ادفع",
          paid: "مدفوع",
          payNow: "ادفع الآن"
        },
        checkout: {
          title: "تقريباً انتهينا!",
          steps: {
            data: "البيانات",
            customize: "تخصيص",
            review: "مراجعة"
          },
          messages: {
            notFound: "غير موجود",
            paymentNotice: "بعد الدفع، قم بتحديث الصفحة!",
            subscriptionSuccess: "تم الاشتراك بنجاح! في انتظار معالجة الدفع"
          },
          buttons: {
            back: "عودة",
            pay: "ادفع",
            next: "التالي"
          },
          pricing: {
            users: "المستخدمون",
            connection: "الاتصال",
            queues: "قوائم الانتظار",
            select: "حدد",
            perMonth: "/شهر"
          },
          review: {
            title: "ملخص الاشتراك"
          },
          success: {
            total: "الإجمالي",
            copied: "تم النسخ",
            copyQr: "نسخ رمز QR",
            finalizeMessage: "لإكمال العملية، ما عليك سوى الدفع عن طريق مسح أو لصق رمز Pix أعلاه :)",
            licenseRenewed: "تم تجديد ترخيصك حتى"
          },
          planDetails: {
            title: "تفاصيل الخطة",
            billing: "الفوترة: شهرية"
          },
          paymentInfo: {
            title: "معلومات الدفع",
            email: "البريد الإلكتروني:",
            name: "الاسم:",
            document: "CPF/CNPJ:",
            total: "الإجمالي:"
          }
        }
      },
      dashboard: {
        title: "لوحة التحكم",
        subtitle: "نظرة عامة على عمليات الدعم في الوقت الفعلي",
        buttons: {
          filter: "تصفية",
          export: "تصدير"
        },
        tabs: {
          indicators: "المؤشرات",
          assessments: "NPS",
          attendants: "الوكلاء",
          performance: "الأداء"
        },
        charts: {
          performance: "الرسوم البيانية",
          userPerformance: "رسوم بيانية للمستخدمين",
          hourlyServices: "الخدمات في الساعة",
          ticketsLabel: "التذاكر",
          score: "النقاط",
          perDay: {
            title: "الخدمات اليوم: ",
          },
          errorFetchingTickets: "خطأ في جلب معلومات التذاكر",
          noDataAvailable: "لا توجد بيانات متاحة للفترة المحددة.",
          avgPerDay: "متوسط/يوم",
          peak: "الذروة",
          totalAgents: "الوكلاء",
          topAgent: "الأبرز",
          day: "يوم",
          days: "أيام",
          presets: {
            today: "اليوم",
            month: "الشهر"
          },
        },
        cards: {
          inAttendance: "في الخدمة",
          waiting: "انتظار",
          activeAttendants: "وكلاء نشطون",
          finalized: "مكتملة",
          newContacts: "جهات اتصال جديدة",
          totalReceivedMessages: "رسائل مستلمة",
          totalSentMessages: "رسائل مرسلة",
          averageServiceTime: "متوسط وقت الخدمة",
          averageWaitingTime: "متوسط وقت الانتظار",
          status: "الحالة (الحالية)",
          activeTickets: "تذاكر نشطة",
          passiveTickets: "تذاكر خاملة",
          groups: "مجموعات",
        },
        users: {
          name: "الاسم",
          numberAppointments: "عدد الخدمات",
          statusNow: "الحالي",
          totalCallsUser: "إجمالي الخدمات لكل مستخدم",
          totalAttendances: "إجمالي الخدمات",
          totalLabel: "إجمالي الخدمات: {{count}}",
          queues: "طوابير",
          defaultQueue: "الاتصال الافتراضي",
          workingHours: "ساعات العمل",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          farewellMessage: "رسالة وداع",
          theme: "الموضوع الافتراضي",
          menu: "القائمة الافتراضية"
        },
        date: {
          initialDate: "التاريخ الأولي",
          finalDate: "التاريخ النهائي",
        },
        licence: {
          available: "متاح حتى",
        },
        assessments: {
          totalCalls: "إجمالي الخدمات",
          callsWaitRating: "خدمات في انتظار التقييم",
          callsWithoutRating: "خدمات بدون تقييم",
          ratedCalls: "خدمات مقيمة",
          evaluationIndex: "مؤشر التقييم",
          score: "النتيجة",
          prosecutors: "المحامون",
          neutral: "محايد",
          detractors: "منتقدون",
          generalScore: "نتيجة NPS الإجمالية",
        },
        status: {
          online: "متصل",
          offline: "غير متصل",
        },
        filters: {
          title: "الفلاتر",
          initialDate: "البداية",
          finalDate: "النهاية",
          filterButton: "تصفية",
        },
        errors: {
          loadData: "لم نتمكن من تحميل بيانات لوحة التحكم.",
          exportExcel: "خطأ في التصدير إلى Excel.",
        },
        export: {
          sheetName: "تقرير الوكلاء",
          fileName: "agent-report.xlsx",
        },
        nps: {
          overallScore: "نتيجة NPS الإجمالية",
        },
      },
      reports: {
        title: "تقارير الاستطلاعات المنجزة",
        subtitle: "السجل الكامل للخدمات مع التصفية والتصدير",
        kpis: {
          total: "إجمالي التذاكر",
          open: "مفتوحة",
          closed: "مغلقة",
          rated: "مُقيَّمة",
        },
        table: {
          id: "المعرف",
          whatsapp: "الاتصال",
          contact: "جهة الاتصال",
          user: "الوكيل",
          queue: "الطابور",
          status: "الحالة",
          lastMessage: "آخر رسالة",
          dateOpen: "افتُتح في",
          dateClose: "أُغلق في",
          supportTime: "وقت الخدمة",
          NPS: "NPS",
          actions: "إجراءات",
          empty: "لم يتم العثور على خدمات للفلاتر المطبقة.",
        },
        buttons: {
          filter: "تصفية",
          onlyRated: "المُقيَّمة فقط",
          export: "تصدير",
          clear: "مسح الفلاتر",
        },
        filters: "الفلاتر",
        contactSearch: "البحث عن جهة اتصال...",
        contactSearchHint: "اكتب حرفين على الأقل",
        operator: "المشغل",
        period: "الفترة",
        until: "حتى",
        date: "التاريخ",
        reportTitle: "التقارير",
        calls: "الخدمات",
        search: "الاستطلاعات",
        durationCalls: "مدة الخدمات",
        grupoSessions: "خدمات الجماعات",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "جاري إنشاء تقرير مضغوط، يرجى الانتظار.",
          errorToast: "خطأ في إنشاء التقرير",
          back: "العودة",
          groupServiceReport: "تقرير خدمات الجماعات",
          loading: "جاري التحميل...",
          contact: "جهة الاتصال",
          dateOpen: "تاريخ الافتتاح",
          dateLastUpdated: "تاريخ آخر تحديث",
          agent: "من قدم الخدمة",
          agentClosed: "من أغلق",
          waitingAssistance: "في انتظار المساعدة",
          process: "في الخدمة",
        },
        researchReports: {
          response: "الاستجابة",
          active: "(نشط)",
          inactive: "(غير نشط)",
          quantity: "الكمية",
          percentage: "النسبة المئوية",
          title: "تقارير الاستطلاعات المنجزة",
          activeSearch: "البحث النشط",
          inactiveSearch: "البحث غير النشط",
        },
        ticketDurationDetail: {
          msgToast: "جاري إنشاء تقرير مضغوط، يرجى الانتظار.",
          title: "تقرير مدة الخدمة",
          startService: "بداية الخدمة",
          lastUpdated: "آخر تحديث",
          lastAgent: "آخر وكيل",
          durationFinished: "المدة بعد الانتهاء",
        },
        ticketDuration: {
          title: "تقرير مدة الخدمات",
          contact: "جهة الاتصال",
          open: "مفتوح",
          pending: "معلق",
          finished: "مكتمل",
          durationFinished: "مدة المكتملة",
          durationAfterFinished: "المدة بعد الانتهاء",
          actions: "الإجراءات",
        },
        ticketReports: {
          msgToast: "جاري إنشاء تقرير مضغوط، يرجى الانتظار.",
          title: "تقرير الخدمة",
        },
        pdf: {
          title: "قائمة الخدمات المكتملة",
          exportTitle: "قائمة خدمات المجموعات المكتملة",
        },
        form: {
          initialDate: "التاريخ الأولي",
          finalDate: "التاريخ النهائي",
        },
        excel: {
          connection: "الاتصال",
          contact: "جهة الاتصال",
          user: "المستخدم",
          queue: "الطابور",
          status: "الحالة",
          lastMessage: "آخرRسالة",
          dateOpen: "تاريخالافتتاح",
          timeOpen: "وقتالافتتاح",
          dateClose: "تاريخالإغلاق",
          timeClose: "وقتالإغلاق",
          supportTime: "وقتالدعم",
          nps: "nps",
          fileName: "تقرير-الخدمات.xlsx",
          sheetName: "تقريرالخدمات",
        },
        tooltips: {
          ticketLogs: "سجلات التذكرة",
          accessTicket: "الوصول للتذكرة",
          exportExcel: "تصدير إلى Excel",
        },
      },
      kanban: {
        title: "كانبان",
        subtitle: "تصور التذاكر بتنسيق كانبان",
        searchPlaceholder: "بحث",
        subMenus: {
          list: "اللوحة",
          tags: "المسارات",
        },
        ticketNumber: "تذكرة رقم ",
        viewTicket: "عرض التذكرة",
        startDate: "تاريخ البداية",
        endDate: "تاريخ النهاية",
        search: "بحث",
        addColumns: "+ إضافة أعمدة",
        ticketTagRemoved: "تم إزالة علامة التذكرة!",
        ticketTagAdded: "تم إضافة علامة التذكرة بنجاح!",
        ticketMoveError: "خطأ في نقل التذكرة",
        iconChannelError: "خطأ",
        noTickets: "لا توجد تذاكر",
        emptyStateTags: "لم يتم إنشاء علامات كانبان",
        emptyStateTagsDescription: "أنشئ علامة كانبان الأولى لبدء تنظيم التذاكر",
        createFirstTag: "إنشاء العلامة الأولى",
        emptyStateTickets: "لم يتم العثور على تذاكر",
        emptyStateTicketsDescription: "اضبط مرشحات التاريخ أو أنشئ تذاكر جديدة",
        errorTitle: "خطأ في تحميل كانبان",
        errorDescription: "حدث خطأ أثناء جلب البيانات. يرجى المحاولة مرة أخرى.",
        retry: "حاول مرة أخرى",
        card: {
          menu: "المزيد من الخيارات",
          editSchedule: "تعديل الموعد",
          deleteSchedule: "حذف الموعد",
        },
      },
      campaigns: {
        title: "الحملات",
        searchPlaceholder: "بحث",
        subMenus: {
          list: "قائمة",
          listContacts: "قائمة جهات الاتصال",
          settings: "الإعدادات",
        },
        status: {
          inactive: "غير نشطة",
          scheduled: "مجدولة",
          inProgress: "قيد التنفيذ",
          cancelled: "ملغاة",
          finished: "منتهية",
        },
        common: {
          none: "لا شيء",
          notDefined: "غير محدد",
          noSchedule: "لا يوجد جدولة",
          notCompleted: "غير مكتملة",
          enabled: "مفعلة",
          disabled: "معطلة",
        },
        modal: {
          tabLabels: {
            msg1: "رسالة 1",
            msg2: "رسالة 2",
            msg3: "رسالة 3",
            msg4: "رسالة 4",
            msg5: "رسالة 5",
          },
          helpText: "استخدم متغيرات مثل {nome}, {numero}, {email} أو حدد متغيرات مخصصة.",
        },
        settings: {
          randomInterval: "فترة إرسال عشوائية",
          noBreak: "بلا فاصل",
          intervalGapAfter: "فترة أكبر بعد",
          undefined: "غير محدد",
          messages: "رسائل",
          laggerTriggerRange: "فترة إطلاق أكبر",
          addVar: "إضافة متغير",
          save: "حفظ",
          close: "إغلاق",
          add: "إضافة",
          shortcut: "اختصار",
          content: "المحتوى",
        },
        buttons: {
          add: "حملة جديدة",
          contactLists: "قوائم جهات الاتصال",
          stopCampaign: "إيقاف الحملة",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          contactList: "قائمة جهات الاتصال",
          option: "لا شيء",
          disabled: "معطلة",
          enabled: "مفعلة",
          status: "الحالة",
          scheduledAt: "مجدولة",
          completedAt: "مكتملة",
          confirmation: "التأكيد",
          actions: "الإجراءات",
        },
        dialog: {
          new: "حملة جديدة",
          update: "تحرير الحملة",
          readonly: "للعرض فقط",
          help: "استخدم متغيرات مثل {nome}, {numero}, {email} أو حدد متغيرات مخصصة.",
          form: {
            name: "الاسم",
            message1: "رسالة 1",
            message2: "رسالة 2",
            message3: "رسالة 3",
            message4: "رسالة 4",
            message5: "رسالة 5",
            confirmationMessage1: "رسالة تأكيد 1",
            confirmationMessage2: "رسالة تأكيد 2",
            confirmationMessage3: "رسالة تأكيد 3",
            confirmationMessage4: "رسالة تأكيد 4",
            confirmationMessage5: "رسالة تأكيد 5",
            messagePlaceholder: "محتوى الرسالة",
            whatsapp: "الاتصال",
            status: "الحالة",
            scheduledAt: "مجدولة",
            confirmation: "التأكيد",
            contactList: "قائمة جهات الاتصال",
            tagList: "العلامات",
            statusTicket: "حالة التذكرة",
            openTicketStatus: "مفتوح",
            pendingTicketStatus: "معلق",
            closedTicketStatus: "مغلق",
            enabledOpenTicket: "مفعل",
            disabledOpenTicket: "معطل",
            openTicket: "فتح تذكرة",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء الإرسال",
            restart: "إعادة تشغيل الإرسال",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه.",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          cancel: "تم إلغاء الحملة",
          restart: "تم إعادة تشغيل الحملة",
          deleted: "تم حذف السجل",
        },
        noPermission: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة! نحن نقوم بإعادة توجيهك.",
      },
      campaignReport: {
        title: "تقرير",
        subtitle: "تابع تقدم الحملة ونتائجها",
        inactive: "غير نشطة",
        scheduled: "مجدولة",
        process: "قيد التنفيذ",
        cancelled: "ملغاة",
        finished: "منتهية",
        campaign: "حملة",
        validContacts: "جهات اتصال صالحة",
        confirmationsRequested: "تأكيدات مطلوبة",
        confirmations: "تأكيدات",
        deliver: "تم التسليم",
        connection: "الاتصال",
        contactLists: "قائمة جهات الاتصال",
        schedule: "الجدولة",
        conclusion: "الانتهاء",
        noPermission: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة! نحن نقوم بإعادة توجيهك.",
        status: "الحالة:",
        of: "من",
      },
      campaignsConfig: {
        title: "إعدادات الحملات",
        noPermissionMessage: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة! نحن نقوم بإعادة توجيهك.",
        settingsSaved: "تم حفظ الإعدادات",
        intervals: "الفترات",
        seconds: "ثوانٍ",
      },
      campaignsPhrase: {
        title: "الحملات",
        subtitle: "إدارة الحملات التي يتم تشغيلها بواسطة العبارات",
        phraseDeleted: "تم حذف العبارة",
        phraseUpdated: "تم تحديث العبارة بنجاح!",
        phraseCreated: "تم إنشاء العبارة بنجاح!",
        addCampaign: "حملة",
        table: {
          name: "الاسم",
          status: "الحالة",
          active: "نشط",
          inactive: "غير نشط",
          empty: "لم يتم العثور على حملات عبارات",
          emptySearch: "لا توجد حملات مطابقة للبحث.",
        },
        modal: {
          editTitle: "تحرير حملة تدفق بالعبارة",
          newTitle: "حملة تدفق جديدة بالعبارة",
          nameLabel: "اسم مشغل العبارة",
          flowLabel: "اختر تدفقًا",
          flowPlaceholder: "اختر تدفقًا",
          connectionPlaceholder: "اختر اتصالًا",
          phraseLabel: "أي عبارة تشغل التدفق؟",
          matchTypeLabel: "نوع المطابقة",
          matchTypeExact: "مطابقة تامة",
          matchTypeContains: "يحتوي على الكلمة",
          matchTypeTooltip: "تامة: يجب أن تطابق الرسالة الكلمة تمامًا. يحتوي: يمكن أن تظهر الكلمة في أي مكان في الرسالة",
          statusLabel: "الحالة",
          cancelButton: "إلغاء",
          saveButton: "حفظ الحملة",
          createButton: "إنشاء حملة",
        },
      },
      compaies: {
        title: "الشركات",
        subtitle: "إدارة جميع الشركات (tenants) في المنصة",
        actions: {
          new: "شركة جديدة",
        },
        modal: {
          createTitle: "شركة جديدة",
          editTitle: "تعديل الشركة",
          cancel: "إلغاء",
          incrementDueDate: "تقديم تاريخ الاستحقاق وفقاً للتكرار",
        },
        empty: {
          list: "لا توجد شركات مسجلة بعد.",
          search: "لا توجد شركات مطابقة للبحث.",
        },
        due: {
          expired: "منتهية",
        },
        form: {
          documentLabel: "(اختياري) CPF/CNPJ",
          documentPlaceholder: "000.000.000-00 أو 00.000.000/0000-00",
          documentInvalid: "CPF/CNPJ غير صالح",
          documentDuplicate: "CPF/CNPJ مسجل بالفعل",
          documentNotProvided: "غير متوفر",
          nameRequired: "الاسم مطلوب",
          emailRequired: "البريد الإلكتروني مطلوب",
        },
        searchPlaceholder: "البحث عن الشركات...",
        searchLabel: "حقل البحث عن الشركات",
        clearSearch: "مسح البحث",
        notifications: {
          noPermission: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة! نحن نقوم بإعادة توجيهك."
        },
        toasts: {
          deleted: "تم حذف الشركة"
        },
        buttons: {
          add: "إضافة شركة"
        },
        table: {
          ID: "معرّف",
          status: "الحالة",
          name: "الاسم",
          email: "البريد الإلكتروني",
          namePlan: "الخطة",
          value: "القيمة",
          createdAt: "تم إنشاؤها في",
          dueDate: "تاريخ الاستحقاق",
          lastLogin: "آخر دخول",
          folderSize: "حجم المجلد",
          totalFiles: "إجمالي الملفات",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
          yes: "نعم",
          no: "لا"
        },
        confirmationModal: {
          deleteTitle: "حذف الشركة",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه."
        }
      },
      contactModal: {
        title: {
          add: "إضافة جهة اتصال",
          edit: "تحرير جهة اتصال",
        },
        form: {
          mainInfo: "بيانات جهة الاتصال",
          extraInfo: "معلومات إضافية",
          name: "الاسم",
          number: "رقم واتساب",
          optional: "اختياري",
          email: "البريد الإلكتروني",
          extraName: "اسم الحقل",
          extraValue: "الوصف",
          chatBotContact: "إلغاء تنشيط الشات بوت",
          termsLGDP: "تم قبول شروط LGPD في:",
          whatsapp: "اتصال المصدر: ",
          numberPlaceholder: "5513912344321",
          emailPlaceholder: "عنوان البريد الإلكتروني"
        },
        buttons: {
          addExtraInfo: "إضافة معلومة",
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ جهة الاتصال بنجاح.",
      },
      flowbuilder: {
        title: "تدفقات المحادثة",
        subtitle: "إدارة تدفقات المحادثة وأتمتة الخدمة",
        subMenus: {
          campaign: "تدفق الحملة",
          conversation: "تدفق المحادثة"
        },
        buttons: {
          add: "إضافة تدفق",
          editName: "تحرير الاسم",
          editFlow: "تحرير التدفق",
          duplicate: "تكرار",
          delete: "حذف"
        },
        table: {
          status: "الحالة"
        },
        status: {
          active: "نشط",
          inactive: "غير نشط"
        },
        toasts: {
          deleteSuccess: "تم حذف التدفق بنجاح",
          duplicateSuccess: "تم تكرار التدفق بنجاح"
        },
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من أنك تريد حذف هذا التدفق؟ سيتم فقدان جميع التكاملات ذات الصلة.",
          duplicateTitle: "هل تريد تكرار التدفق {flowName}؟",
          duplicateMessage: "هل أنت متأكد من أنك تريد تكرار هذا التدفق؟"
        }
      },
      flowbuilderModal: {
        flowNotIdPhrase: "التدفق الافتراضي",
        title: {
          add: "إضافة تدفق",
          edit: "تحرير التدفق"
        },
        validation: {
          tooShort: "قصير جداً!",
          tooLong: "طويل جداً!",
          required: "أدخل اسماً!"
        }
      },
      companyModal: {
        title: {
          add: "إضافة شركة",
          edit: "تحرير الشركة"
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          passwordDefault: "كلمة المرور",
          numberAttendants: "المستخدمون",
          numberConections: "الاتصالات",
          status: "نشط"
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء"
        },
        success: "تم حفظ الشركة بنجاح."
      },
      channels: {
        whatsapp: "واتساب",
        whatsappOfficial: "واتساب API الرسمي",
        facebook: "فيسبوك",
        instagram: "إنستغرام"
      },
      connections: {
        title: "الاتصالات",
        subtitle: "إدارة قنوات الخدمة الخاصة بك (واتساب، فيسبوك، إنستغرام)",
        waitConnection: "انتظر... سيتم إعادة تشغيل اتصالاتك!",
        newConnection: "اتصال جديد",
        restartConnections: "إعادة تشغيل الاتصالات",
        callSupport: "اتصال بالدعم",
        toasts: {
          deleted: "تم حذف الاتصال بنجاح!",
          closedimported: "نحن نغلق التذاكر المستوردة، يرجى الانتظار لحظة",
          officialApiSoon: "تكامل API الرسمي قريباً!"
        },
        confirmationModal: {
          closedImportedTitle: "إغلاق التذاكر المستوردة",
          closedImportedMessage: "إذا أكدت، سيتم إغلاق جميع التذاكر المستوردة",
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
          disconnectTitle: "قطع الاتصال",
          disconnectMessage: "هل أنت متأكد؟ ستحتاج إلى مسح رمز QR مرة أخرى."
        },
        buttons: {
          add: "إضافة اتصال",
          disconnect: "قطع الاتصال",
          tryAgain: "حاول مرة أخرى",
          qrcode: "رمز QR",
          newQr: "رمز QR جديد",
          closedImported: "إغلاق جميع التذاكر المستوردة",
          preparing: "تحضير الرسائل للاستيراد",
          importing: "استيراد رسائل واتساب",
          processed: "تمت المعالجة",
          in: "من",
          connecting: "جاري الاتصال",
          edit: "تعديل",
          delete: "حذف"
        },
        empty: "لا توجد اتصالات مسجلة.",
        status: {
          connected: "متصل",
          disconnected: "غير متصل",
          qrcode: "رمز QR",
          pairing: "جاري الاقتران",
          timeout: "انتهت المهلة",
          comingSoon: "قريباً"
        },
        typography: {
          processed: "تمت المعالجة",
          in: "من",
          date: "تاريخ الرسالة"
        },
        toolTips: {
          disconnected: {
            title: "فشل في بدء جلسة واتساب",
            content: "تأكد من أن هاتفك متصل بالإنترنت وحاول مرة أخرى، أو اطلب رمز QR جديد"
          },
          qrcode: {
            title: "في انتظار مسح رمز QR",
            content: "انقر على زر 'رمز QR' وامسح رمز QR بهاتفك لبدء الجلسة"
          },
          connected: {
            title: "تم إنشاء الاتصال!"
          },
          timeout: {
            title: "فُقد الاتصال بالهاتف",
            content: "تأكد من أن هاتفك متصل بالإنترنت وأن واتساب مفتوح، أو انقر على 'قطع الاتصال' للحصول على رمز QR جديد"
          }
        },
        table: {
          name: "الاسم",
          status: "الحالة",
          lastUpdate: "آخر تحديث",
          default: "افتراضي",
          actions: "الإجراءات",
          session: "الجلسة",
          number: "رقم واتساب",
          channel: "القناة"
        },
        iconChannel: {
          error: "خطأ"
        }
      },
      whatsappModal: {
        form: {
          identitySectionTitle: "التعريف",
          behaviorSectionTitle: "السلوك",
          tokenRefreshTooltip: "إنشاء رمز جديد",
          tokenCopyTooltip: "نسخ الرمز",
          queueIdImportMessagesDesc: "الطابور الذي ستُوجَّه إليه التذاكر الناتجة عن الاستيراد. حدد طابوراً معيناً لعزل السجل المستورد عن التذاكر النشطة.",
          sendIdQueueDesc: "الطابور الافتراضي لاستلام التذاكر من جهات الاتصال غير المخصصة بعد لأي طابور. يعمل كآلية احتياطية تلقائية.",
          timeSendQueueDesc: "الوقت (بالدقائق) الذي ينتظره النظام قبل نقل جهة الاتصال غير المخصصة إلى الطابور الافتراضي أعلاه. استخدم 0 لإيقاف إعادة التوجيه التلقائي.",
          queuesSectionTitle: "طوابير الخدمة",
          queuesSectionDesc: "الطوابير (الأقسام) التي ستستلم التذاكر من هذا الاتصال. سيكون لدى الموظفين الأعضاء في هذه الطوابير وصول إلى التذاكر.",
          queuesHelp: "اختر طابوراً واحداً أو أكثر. كل رسالة تأتي عبر هذا الاتصال ستكون متاحة للموظفين المرتبطين بهذه الطوابير. إذا لم يتم اختيار أي طابور، فلن يرى التذاكر سوى المسؤولين.",
          integrationSectionTitle: "تكامل خارجي",
          integrationSectionDesc: "يوجه الرسائل من هذا الاتصال إلى نظام خارجي (Typebot، Dialogflow، n8n، webhook مخصص، إلخ) بدلاً من الطوابير الداخلية.",
          integrationHelp: "عند اختيار تكامل، تُعالج الرسائل بواسطة النظام الخارجي المُكوَّن في الإعدادات > التكاملات. مفيد لأتمتة الذكاء الاصطناعي أو الروبوتات المخصصة. ملاحظة: اختيار تكامل يمحو الطوابير (متبادلان حصرياً).",
          integrationsInfoTitle: "ⓘ كيف تعمل الطوابير والتكاملات",
          integrationsInfoText: "يمكن لكل اتصال توجيه الرسائل الواردة بطريقتين:<ul><li><strong>الطوابير:</strong> توزع التذاكر بين الموظفين البشريين المنظمين في أقسام.</li><li><strong>تكامل خارجي:</strong> يرسل الرسائل إلى نظام آلي (روبوت، ذكاء اصطناعي، webhook).</li></ul><strong>مهم:</strong> الخياران متبادلان حصرياً — اختيار أحدهما يمحو الآخر تلقائياً.",
          npsInfoTitle: "ⓘ ما هو NPS وكيف يعمل هنا",
          npsInfoText: "<strong>NPS (مؤشر صافي الترويج)</strong> هو استطلاع يُرسل إلى العميل <strong>بعد إغلاق التذكرة</strong>، يطلب تقييماً من <strong>0 إلى 10</strong> حول التجربة.<ul><li>يتم إرسال السؤال تلقائياً بواسطة روبوت النظام.</li><li>يُحفظ التقييم المستلم ويمكن مراجعته في التقارير.</li><li>إذا لم يرد العميل، يعيد النظام الإرسال حتى الحد الأقصى المحدد.</li><li>بعد انتهاء المهلة، يتم إغلاق تذكرة التقييم تلقائياً.</li></ul><strong>مهم:</strong> لتفعيل إرسال NPS يجب تفعيل <em>تقييم المستخدم</em> في الإعدادات → الشركة.",
          npsSurveySectionTitle: "استطلاع التقييم",
          npsRulesSectionTitle: "قواعد الإرسال",
          ratingMessageDesc: "النص المرسل إلى العميل لطلب التقييم. استخدم جملة قصيرة وودودة. المقياس الإلزامي من 0 إلى 10. مثال: 'من 0 إلى 10، كم تنصح بخدمتنا؟'",
          maxUseBotQueuesNPSDesc: "العدد الأقصى لمرات إعادة إرسال سؤال التقييم في حال لم يرد العميل. الموصى به: محاولتان أو ثلاث.",
          expiresTicketNPSDesc: "الوقت (بالدقائق) الذي ينتظره النظام للحصول على رد قبل إغلاق تذكرة التقييم تلقائياً. استخدم 0 لعدم الإغلاق التلقائي أبداً.",
          imageLabel: "صورة الاتصال",
          imageDesc: "صورة/فيديو اختياري للتعرف على هذا الاتصال بصرياً في قائمة قنواتك.",
          nameDesc: "الاسم الداخلي للاتصال (يراه فريقك فقط). استخدم اسماً وصفياً مثل 'دعم المبيعات' أو 'مبيعات BR'.",
          defaultDesc: "عند التفعيل، يصبح هذا هو الاتصال الافتراضي للإرسال التلقائي (الحملات، التكاملات، API الخارجي).",
          groupDesc: "يسمح باستقبال رسائل مجموعات واتساب وفتح تذاكر في النظام. معطل افتراضياً لتقليل الضوضاء.",
          groupAsTicketDesc: "يحدد كيفية التعامل مع رسائل المجموعات: 'مفعل' يفتح تذكرة لكل مجموعة؛ 'معطل' يتجاهل أو يدمج الرسائل.",
          importSectionTitle: "استيراد الرسائل",
          importSectionDesc: "يجلب آخر سجل المحادثات من الجهاز المتصل. اضبطها بحذر: الاستيراد محدود وقد يؤثر على الأداء.",
          importInfoTitle: "ⓘ اقرأ بعناية قبل التفعيل",
          importInfoText: "الاستيراد <strong>لا يجلب كامل سجل واتساب</strong> — فقط الرسائل التي لا تزال في ذاكرة التخزين المؤقت للجهاز.<ul><li><strong>الحد الفعلي:</strong> عادةً ما يمكن استرداد آخر أسابيع/أشهر فقط، حسب استخدام الجهاز.</li><li><strong>سيتم إنهاء الاتصال</strong> عند الحفظ وستحتاج إلى مسح رمز QR مرة أخرى.</li><li><strong>قد يستغرق وقتاً طويلاً</strong> ويسبب حملاً على الخادم أثناء التشغيل.</li><li><strong>التوصية:</strong> للبدء بنظافة، يفضل <strong>إنشاء اتصال جديد</strong> دون استيراد ودع السجل يبنى بشكل طبيعي.</li></ul>",
          importOldMessagesEnable: "استيراد الرسائل من الجهاز",
          importOldMessagesEnableDesc: "يفعّل محاولة استيراد المحادثات المخزنة مؤقتاً من الهاتف عند الاتصال. استخدمها فقط إذا كنت بحاجة فعلية لسجل سابق.",
          importOldMessagesGroups: "استيراد رسائل المجموعات",
          importOldMessagesGroupsDesc: "يضمّن سجل محادثات المجموعات في نطاق الاستيراد. قد يزيد كثيراً من حجم التذاكر التي يتم إنشاؤها.",
          closedTicketsPostImported: "إغلاق التذاكر بعد الاستيراد",
          closedTicketsPostImportedDesc: "يحدد تلقائياً جميع التذاكر التي أنشأها الاستيراد كمغلقة. مفيد لتجنب إزدحام طابور الموظفين.",
          tokenSectionTitle: "رمز التكامل الخارجي",
          tokenSectionDesc: "استخدم هذا الرمز لمصادقة طلبات API باستخدام هذا الاتصال كمرسل. احتفظ به سرياً.",
          queueRedirection: "إعادة توجيه الطابور",
          queueRedirectionDesc: "يحدد إلى أي طابور يتم تحويل جهات الاتصال التي ليس لها طابور مخصص تلقائياً بعد الوقت المحدد.",
          importAlert: "تنبيه: عند الحفظ، سينتهي الاتصال وستحتاج إلى مسح رمز QR مرة أخرى. الاستيراد يجلب فقط ما هو في ذاكرة التخزين المؤقت للجهاز — وليس سجل واتساب الكامل."
        }
      },
      qrcodeModal: {
        title: "ربط واتساب",
        intro: "استخدم واتساب على هاتفك لمسح الرمز على اليمين وربط هذه الجلسة. تستغرق العملية بضع ثوانٍ فقط.",
        step1: "افتح <strong>واتساب</strong> على هاتفك.",
        step2: "اضغط على <strong>المزيد من الخيارات</strong> (Android) أو <strong>الإعدادات</strong> (iPhone).",
        step3: "اختر <strong>الأجهزة المرتبطة</strong> ثم <strong>ربط جهاز</strong>.",
        step4: "وجّه كاميرا الهاتف إلى رمز QR على اليمين.",
        statusReady: "جاهز للمسح",
        waiting: "في انتظار رمز QR..."
      },
      flowBuilder: {
        welcomeFlow: "تدفق الترحيب",
        welcomeFlowLabel: "اختر تدفق ترحيب",
        welcomeFlowDescription: "يتم تشغيله عندما يرسل جهة اتصال جديدة تماماً (غير موجودة بعد في قاعدة بياناتك) أول رسالة إلى هذا الاتصال.",
        welcomeFlowHelp: "استخدمه لتقديم الشركة، طلب الاسم، جمع البيانات الأولية أو توجيه العميل تلقائياً إلى طابور. يجب إنشاء التدفق في FlowBuilder قبل ظهوره هنا. اتركه 'معطل' إذا كنت تفضل أن تذهب جهات الاتصال الجديدة مباشرة إلى الطابور الافتراضي.",
        defaultResponseFlow: "تدفق الرد الافتراضي",
        defaultResponseFlowLabel: "اختر تدفق رد افتراضي",
        defaultResponseFlowDescription: "يتم تشغيله لأي رسالة لا تتطابق مع كلمة مفتاحية مكونة. انتباه: يتم تشغيله أيضاً عندما تكون الخدمة مغلقة لأكثر من 6 ساعات.",
        defaultResponseFlowHelp: "استخدمه للرد تلقائياً عندما يكتب العميل شيئاً غير متوقع، أو بعد فترة طويلة من الخمول. تنبيه: إذا تم تكوينه بشكل غير صحيح فقد يربك العميل في المحادثات النشطة. يُنصح باستخدام تدفق قصير يدعو فقط للتواصل في ساعات العمل. اتركه 'معطل' لإسكات الردود التلقائية.",
        infoTitle: "ⓘ ما هو التدفق الافتراضي",
        infoText: "يسمح بربط هذا الاتصال بتدفقات آلية مُنشأة في <strong>FlowBuilder</strong>. هناك مشغلان:<ul><li><strong>تدفق الترحيب:</strong> يعمل عند أول رسالة من جهة اتصال جديدة.</li><li><strong>تدفق الرد الافتراضي:</strong> يعمل عندما لا تتطابق رسالة مع أي كلمة مفتاحية أو عندما تكون الخدمة مغلقة لأكثر من 6 ساعات.</li></ul><strong>للتكوين:</strong> أنشئ التدفق أولاً في <em>FlowBuilder</em> من القائمة الجانبية، ثم اختره هنا. التدفقات تعمل فقط عندما يكون هذا الاتصال متصلاً.",
        title: "التدفق الافتراضي",
        save: "حفظ",
        updatedSuccess: "تم تحديث التدفقات الافتراضية",
        deleteConfirmation: "هل أنت متأكد من أنك تريد حذف هذا التدفق؟ ستفقد جميع التكاملات ذات الصلة.",
      },
      contactImport: {
        title: "استيراد جهات الاتصال من ملف",
        subtitle: "أرسل ملف XLS أو XLSX أو CSV أو TXT لاستيراد جهات الاتصال بالجملة",
        validation: {
          noNumberField: "لم يتم اختيار حقل رقم جهة الاتصال",
          noNameField: "لم يتم اختيار حقل اسم جهة الاتصال",
          noContactsSelected: "لا توجد جهة اتصال مختارة",
          fieldAlreadySelected: "تم اختيار الحقل {{field}} مسبقاً."
        },
        messages: {
          successComplete: "تم الاستيراد بنجاح",
          successWithErrors: "تم الاستيراد بنجاح، ولكن كانت هناك بعض الأخطاء",
          importing: "جاري الاستيراد... يرجى الانتظار",
          processing: "جاري معالجة الملف...",
          invalidFile: "ملف غير صالح!",
          contactsCreated: "جهات اتصال تم إنشاؤها",
          contactsIgnored: "جهات اتصال تم تجاهلها (رقم غير صالح أو غير محدد للتحديث)"
        },
        fields: {
          name: "الاسم",
          number: "الرقم",
          email: "البريد الإلكتروني",
          tags: "العلامات",
          followUp: "متابعة (ملاحظات)",
          productName: "المنتج (الاسم)",
          productStatus: "المنتج (الحالة)"
        },
        buttons: {
          downloadModel: "تحميل النموذج",
          validateWhatsApp: "التحقق من جهات الاتصال في واتساب",
          importContacts: "استيراد جهات الاتصال",
          cancel: "إلغاء",
          back: "رجوع"
        },
        dropzone: {
          clickOrDrag: "انقر أو اسحب ملف",
          importantNote: "* مهم: يتم قبول الملفات بالامتدادات التالية فقط: xls، xlsx، csv، txt"
        },
        sheetName: "جهات الاتصال",
        sampleContact: {
          name: "أحمد",
          number: "966501234567",
          email: "ahmed@email.com",
          tags: "عميل, مهم",
          followUp: "",
          productName: "دورة تسويق",
          productStatus: "مكتمل"
        },
        filters: {
          filter: "تصفية",
          clearAll: "مسح الفلاتر",
          noResults: "لم يتم العثور على نتائج"
        }
      },
      chat: {
        noTicketMessage: "اختر تذكرة لبدء المحادثة.",
        deleteConversationTitle: "حذف المحادثة",
        deleteConversationMessage: "هذا الإجراء لا يمكن التراجع عنه، تأكيد؟",
        messagePlaceholder: "اكتب رسالتك...",
        sendButtonTooltip: "إرسال رسالة",
        noMessagesYet: "لا توجد رسائل بعد. ابدأ المحادثة!",
        loadingMessages: "جاري تحميل الرسائل...",
        popover: {
          buttonTooltip: "المحادثات الداخلية",
          loading: "جاري تحميل المحادثات...",
          noChats: "لا توجد محادثات متاحة",
          notificationNotSupported: "هذا المتصفح لا يدعم الإشعارات",
          accessibilityLabel: "قائمة المحادثات الداخلية",
        },
      },
      userStatus: {
        online: "متصل",
        offline: "غير متصل",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "يجب أن يكون هناك واتساب افتراضي واحد على الأقل.",
        ERR_NO_DEF_WAPP_FOUND: "لم يتم العثور على واتساب افتراضي. تحقق من صفحة الاتصالات.",
        ERR_WAPP_NOT_INITIALIZED: "لم يتم تهيئة جلسة واتساب هذه. تحقق من صفحة الاتصالات.",
        ERR_WAPP_CHECK_CONTACT: "تعذر التحقق من جهة اتصال واتساب. تحقق من صفحة الاتصالات",
        ERR_WAPP_INVALID_CONTACT: "هذا ليس رقم واتساب صحيح.",
        ERR_WAPP_DOWNLOAD_MEDIA: "تعذر تنزيل الوسائط من واتساب. تحقق من صفحة الاتصالات.",
        ERR_INVALID_CREDENTIALS: "خطأ في المصادقة. حاول مرة أخرى.",
        ERR_SENDING_WAPP_MSG: "خطأ في إرسال رسالة واتساب. تحقق من صفحة الاتصالات.",
        ERR_DELETE_WAPP_MSG: "تعذر حذف رسالة واتساب.",
        ERR_OTHER_OPEN_TICKET: "يوجد بالفعل تذكرة مفتوحة لهذا الاتصال.",
        ERR_TICKET_ALREADY_ACCEPTED: "تم قبول هذه التذكرة بالفعل من قبل وكيل آخر.",
        ERR_SESSION_EXPIRED: "انتهت صلاحية الجلسة. يرجى تسجيل الدخول.",
        ERR_USER_CREATION_DISABLED: "تم إلغاء إنشاء المستخدم من قبل المسؤول.",
        ERR_NO_PERMISSION: "ليس لديك إذن للوصول إلى هذا المورد.",
        ERR_DUPLICATED_CONTACT: "يوجد بالفعل جهة اتصال بهذا الرقم.",
        ERR_NO_SETTING_FOUND: "لم يتم العثور على إعداد بهذا المعرف.",
        ERR_NO_CONTACT_FOUND: "لم يتم العثور على جهة اتصال بهذا المعرف.",
        ERR_NO_TICKET_FOUND: "لم يتم العثور على تذكرة بهذا المعرف.",
        ERR_NO_USER_FOUND: "لم يتم العثور على مستخدم بهذا المعرف.",
        ERR_NO_WAPP_FOUND: "لم يتم العثور على واتساب بهذا المعرف.",
        ERR_CREATING_MESSAGE: "خطأ في إنشاء رسالة في قاعدة البيانات.",
        ERR_CREATING_TICKET: "خطأ في إنشاء تذكرة في قاعدة البيانات.",
        ERR_FETCH_WAPP_MSG: "خطأ في جلب الرسالة من واتساب، ربما تكون قديمة جداً.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "هذا اللون قيد الاستخدام بالفعل، اختر آخر.",
        ERR_WAPP_GREETING_REQUIRED: "رسالة الترحيب إجبارية عندما يكون هناك أكثر من طابور واحد.",
        ERR_OUT_OF_HOURS: "خارج ساعات العمل!",
        ERR_GENERIC_ERROR: "حدث خطأ!",
      },
      chatInternal: {
        new: "جديد",
        tabs: {
          chats: "المحادثات",
          messages: "الرسائل",
        },
        form: {
          titleLabel: "العنوان",
          titlePlaceholder: "العنوان",
        },
        modal: {
          conversation: "المحادثة",
          title: "العنوان",
          filterUsers: "تصفية بالمستخدمين",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "هذا الإجراء لا يمكن التراجع عنه، تأكيد؟",
        },
      },
      contactLists: {
        title: "قوائم جهات الاتصال",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "قائمة جديدة",
          downloadSample: "تحميل نموذج جدول البيانات",
        },
        dialog: {
          name: "الاسم",
          company: "الشركة",
          okEdit: "تحرير",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تحرير",
          cancel: "إلغاء",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه.",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },
      contactListItems: {
        title: "جهات الاتصال",
        searchPlaceholder: "البحث",
        buttons: {
          add: "جديد",
          lists: "القوائم",
          import: "استيراد",
        },
        dialog: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "واتساب",
          email: "البريد الإلكتروني",
          okEdit: "تحرير",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تحرير",
          cancel: "إلغاء",
        },
        table: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "واتساب",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
          importMessage: "هل تريد استيراد جهات الاتصال من هذه الورقة؟ ",
          importTitlte: "استيراد",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
        downloadTemplate: "انقر هنا لتحميل نموذج جدول البيانات.",
        whatsappValid: "واتساب صحيح",
        whatsappInvalid: "واتساب غير صحيح",
      },
      forwardMessageModal: {
        title: "إعادة توجيه الرسائل إلى",
        searchPlaceholder: "البحث بالاسم أو الرقم",
        recentConversations: "المحادثات الأخيرة",
        createContact: "إنشاء جهة اتصال \"{{name}}\"",
        typeToSearch: "اكتب للبحث عن جهات الاتصال.",
        selectedMessage: "تم اختيار رسالة واحدة",
        selectedMessages: "تم اختيار {{count}} رسائل",
        selectedRecipient: "تم اختيار مستلم واحد",
        selectedRecipients: "تم اختيار {{count}} مستلمين",
        sending: "جارٍ الإرسال إلى {{target}}...",
        buttons: {
          ok: "إعادة توجيه"
        }
      },
      contacts: {
        title: "جهات الاتصال",
        subtitleCount: "جهات اتصال",
        toasts: {
          deleted: "تم حذف جهة الاتصال بنجاح!"
        },
        searchPlaceholder: "بحث...",
        filters: {
          title: "عوامل التصفية",
          any: "أي",
          clearAll: "مسح عوامل التصفية",
          apply: "تطبيق",
          tagsLabel: "العلامات",
        },
        confirmationModal: {
          deleteTitle: "حذف ",
          importTitlte: "استيراد جهات الاتصال",
          exportContact: "تصدير جهات الاتصال",
          deleteMessage: "هل أنت متأكد من أنك تريد حذف جهة الاتصال هذه؟ ستفقد جميع الخدمات ذات الصلة.",
          blockContact: "هل أنت متأكد من أنك تريد حظر جهة الاتصال هذه؟",
          unblockContact: "هل أنت متأكد من أنك تريد إلغاء حظر جهة الاتصال هذه؟",
          importMessage: "هل تريد استيراد جميع جهات الاتصال من الهاتف؟",
          importChat: "استيراد المحادثات",
          wantImport: "هل تريد استيراد جميع المحادثات من الهاتف؟"
        },
        buttons: {
          import: "استيراد جهات الاتصال",
          add: "إضافة جهة اتصال",
          export: "تصدير جهة الاتصال",
          edit: "تعديل",
          block: "حظر",
          unblock: "إلغاء الحظر",
          delete: "حذف",
          startChat: "بدء محادثة"
        },
        forwardMessageModal: {
          title: "إعادة توجيه الرسائل إلى",
          searchPlaceholder: "البحث بالاسم أو الرقم",
          recentConversations: "المحادثات الأخيرة",
          createContact: "إنشاء جهة اتصال \"{{name}}\"",
          typeToSearch: "اكتب للبحث عن جهات الاتصال.",
          selectedMessage: "تم اختيار رسالة واحدة",
          selectedMessages: "تم اختيار {{count}} رسائل",
          selectedRecipient: "تم اختيار مستلم واحد",
          selectedRecipients: "تم اختيار {{count}} مستلمين",
          sending: "جارٍ الإرسال إلى {{target}}...",
          buttons: {
            ok: "إعادة توجيه"
          }
        },
        status: {
          active: "نشط",
          inactive: "غير نشط"
        },
        phantomCleanup: {
          button: "تنظيف الجهات الوهمية",
          help: "لماذا يحدث هذا؟",
          confirmTitle: "تنظيف جهات الاتصال الوهمية",
          confirmMessage: "تم العثور على {{count}} جهة اتصال وهمية. سيتم حذفها نهائياً من قاعدة البيانات. هل تريد المتابعة؟",
          noneFound: "لم يتم العثور على جهات اتصال وهمية. كل شيء نظيف!",
          deletedSuccess: "تمت إزالة جهات الاتصال الوهمية",
          helpTitle: "لماذا تظهر جهات اتصال وهمية؟",
          helpIntro: "جهات الاتصال الوهمية هي إدخالات بأرقام غير صالحة، أو بدون اسم، أو يتم إنشاؤها تلقائياً من النظام دون أن تتطابق مع جهة اتصال حقيقية في WhatsApp.",
          helpWhy: "لماذا يحدث هذا؟",
          helpReason1: "هذا قيد في مكتبة Baileys (التي تتصل بـ WhatsApp Web). عند إرسال أحداث المزامنة من WhatsApp — البث والقوائم والحالات — قد تفسرها المكتبة كجهات اتصال جديدة، حتى لو لم تمثل أشخاصاً حقيقيين.",
          helpReason2: "النتيجة: تظهر إدخالات بأرقام قصيرة جداً، أو ببادئات غريبة (555000…, 120363…)، أو دون أرقام كافية لتكون هاتفاً صالحاً.",
          helpFixTitle: "ماذا يفعل هذا التنظيف؟",
          helpFixBody: "يحدد جهات الاتصال ذات الأرقام غير الصالحة (خارج معيار E.164 أو تسلسلات مكررة أو بادئات مشبوهة) أو التي تم إنشاؤها تلقائياً خارج جهات الاتصال، ويزيلها نهائياً. لا تتأثر جهات الاتصال الشرعية.",
          helpClose: "فهمت"
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          status: "الحالة",
          selectAll: "اختيار جميع جهات الاتصال",
          selectContact: "اختيار جهة اتصال {{name}}",
        },
        menu: {
          importYourPhone: "استيراد من الجهاز الافتراضي",
          importToExcel: "استيراد / تصدير من Excel",
          importExport: "استيراد / تصدير"
        },
        bulkActions: {
          deleteSelected: "حذف المختارة ({{count}})",
          deleteConfirmTitle: "هل أنت متأكد من أنك تريد حذف {{count}} جهات اتصال مختارة؟",
          deleteConfirmMessage: "هذا الإجراء لا يمكن التراجع عنه.",
          deleteSuccess: "تم حذف جهات الاتصال المختارة بنجاح!",
          blockContact: "تم حظر جهة الاتصال",
          unblockContact: "تم إلغاء حظر جهة الاتصال",
          selectConnectionToImport: "اختر الاتصال المراد الاستيراد منه"
        },
        tagsFilter: {
          title: "تصفية حسب العلامات",
          placeholder: "اختر العلامات...",
          noTags: "لا توجد علامات متاحة",
          clearFilters: "مسح المرشحات",
          selectedTags: "العلامات المختارة"
        },
        validation: {
          nameRequired: "الاسم مطلوب",
          numberRequired: "الرقم مطلوب",
          emailRequired: "البريد الإلكتروني مطلوب",
          invalidEmail: "بريد إلكتروني غير صحيح",
          numberExists: "هذا الرقم موجود بالفعل",
          emailExists: "هذا البريد الإلكتروني موجود بالفعل",
          invalidNumber: "رقم غير صحيح",
          numberTooShort: "الرقم قصير جداً",
          numberTooLong: "الرقم طويل جداً",
          nameTooShort: "الاسم قصير جداً",
          nameTooLong: "الاسم طويل جداً",
          tooShort: "قصير جداً!",
          tooLong: "طويل جداً!",
          required: "مطلوب"
        }
      },
      tagModal: {
        title: {
          add: "علامة جديدة",
          edit: "تعديل العلامة",
          addKanban: "مسار جديد",
          editKanban: "تعديل المسار",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          timeLane: "الوقت بالساعات لإعادة التوجيه إلى المسار",
          timeOnLane: "الوقت في المسار",
          days: "أيام",
          hours: "ساعات",
          minutes: "دقائق",
          seconds: "ثوانٍ",
          nextLaneId: "المسار التالي",
          greetingMessageLane: "رسالة ترحيب المسار",
          rollbackLaneId: "العودة إلى المسار بعد استئناف الخدمة"
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        validation: {
          tooShort: "قصير جداً!",
          required: "مطلوب"
        },
        success: "تم حفظ العلامة بنجاح.",
        successKanban: "تم حفظ المسار بنجاح.",
      },
      contactTagListModal: {
        title: "جهات الاتصال",
        table: {
          id: "المعرف",
          name: "الاسم",
          number: "الرقم",
          actions: "الإجراءات"
        }
      },
      todo: {
        newTask: "مهمة جديدة",
        add: "إضافة",
        save: "حفظ",
        task: "مهام",
      },
      contactImportWpModal: {
        modalTitle: "تصدير / استيراد جهات الاتصال",
        title: "تصدير جهات الاتصال إلى Excel",
        buttons: {
          downloadModel: "تحميل نموذج Excel للاستيراد",
          closed: "إغلاق",
          import: "اختر ملف Excel لاستيراد جهات الاتصال"
        },
        form: {
          connection: "اتصال واتساب",
          connectionPlaceholder: "اختر الاتصال...",
          importType: "نوع الاستيراد",
          importAll: "استيراد جميع جهات الاتصال",
          importSelected: "استيراد جهات الاتصال المختارة",
          overwriteExisting: "الكتابة فوق جهات الاتصال الموجودة"
        },
        validation: {
          connectionRequired: "يجب اختيار اتصال",
          noContactsFound: "لم يتم العثور على جهات اتصال للاستيراد"
        },
        progress: {
          importing: "جاري استيراد جهات الاتصال...",
          imported: "جهات الاتصال المستوردة: {count}",
          duplicated: "جهات الاتصال المكررة: {count}",
          failed: "جهات الاتصال الفاشلة: {count}"
        },
        sheetName: "جهات الاتصال",
        columns: {
          name: "الاسم",
          number: "الرقم",
          email: "البريد الإلكتروني",
          tags: "العلامات",
          followUp: "متابعة",
          productName: "المنتج (الاسم)",
          productStatus: "المنتج (الحالة)",
        },
        sampleContact: {
          name: "أحمد",
          number: "966501234567",
          email: "ahmed@email.com",
          tags: "عميل, مهم",
          followUp: "",
          productName: "دورة تسويق",
          productStatus: "مكتمل",
        },
      },
      tagsContainer: {
        title: "علامات جهة الاتصال",
        placeholder: "إضافة علامة...",
        add: "إضافة",
        remove: "إزالة",
        noTags: "لا توجد علامات مخصصة",
        createNew: "إنشاء علامة جديدة",
        searchPlaceholder: "البحث عن علامات...",
        buttons: {
          save: "حفظ العلامات",
          cancel: "إلغاء",
          clear: "مسح الكل"
        },
        validation: {
          tagRequired: "اسم العلامة مطلوب",
          tagExists: "هذه العلامة موجودة بالفعل",
          maxTags: "الحد الأقصى {max} علامة مسموح"
        }
      },
      tags: {
        title: "العلامات",
        subtitle: "نظّم جهات الاتصال بعلامات ملونة",
        empty: "لا توجد علامات مسجلة.",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه العلامة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء."
        },
        table: {
          id: "المعرف",
          name: "الاسم",
          kanban: "Kanban",
          color: "اللون",
          tickets: "السجلات",
          contacts: "جهات الاتصال",
          contact: "جهة اتصال",
          actions: "الإجراءات"
        },
        kpis: {
          total: "إجمالي العلامات",
          totalContacts: "جهات الاتصال الموسومة",
          withContacts: "العلامات المستخدمة"
        },
        tooltips: {
          edit: "تعديل",
          delete: "حذف",
          viewContacts: "عرض جهات الاتصال"
        },
        buttons: {
          add: "علامة جديدة"
        },
        toasts: {
          deleted: "تم حذف العلامة بنجاح."
        }
      },
      tagsKanban: {
        title: "المسارات",
        laneDefault: "مفتوح",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذا المسار؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          name: "الاسم",
          color: "اللون",
          tickets: "التذاكر",
          actions: "الإجراءات",
        },
        buttons: {
          add: "مسار جديد",
          backToKanban: "العودة إلى كانبان",
        },
        toasts: {
          deleted: "تم حذف المسار بنجاح.",
        },
      },
      newTicketModal: {
        title: "إنشاء تذكرة",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        buttons: {
          ok: "حفظ",
          cancel: "إلغاء"
        },
        form: {
          contact: "جهة الاتصال",
          queue: "الطابور",
          message: "الرسالة الأولى",
          contactPlaceholder: "البحث عن جهة اتصال...",
          queuePlaceholder: "اختر الطابور...",
          messagePlaceholder: "رسالة أولى اختيارية..."
        },
        validation: {
          contactRequired: "يجب اختيار جهة اتصال",
          queueRequired: "يجب اختيار طابور"
        }
      },
      showTicketOpenModal: {
        title: {
          header: "خدمة موجودة"
        },
        form: {
          message: "جهة الاتصال هذه قيد الخدمة بالفعل:",
          user: "الوكيل",
          queue: "الطابور",
          messageWait: "جهة الاتصال هذه تنتظر الخدمة بالفعل. تحقق من علامة التبويب في الانتظار!",
          ticketId: "معرف التذكرة",
          status: "الحالة",
          createdAt: "تم إنشاؤها في",
          updatedAt: "تم تحديثها في"
        },
        buttons: {
          goToTicket: "انتقل إلى التذكرة",
          close: "إغلاق",
          transferTicket: "نقل التذكرة"
        },
        status: {
          open: "مفتوح",
          pending: "معلق",
          closed: "مغلق"
        }
      },
      showTicketLogModal: {
        title: {
          header: "السجلات",
        },
        options: {
          create: "تم إنشاء التذكرة.",
          chatBot: "تم تشغيل ChatBot.",
          queue: " - تم تحديد الطابور.",
          open: " بدأ الخدمة.",
          access: "وصل إلى التذكرة.",
          transfered: "نقل التذكرة.",
          receivedTransfer: "استلم التذكرة المنقولة.",
          pending: "أعاد إلى الطابور.",
          closed: "أغلق التذكرة",
          reopen: "أعاد فتح التذكرة",
          redirect: "- تم إعادة التوجيه"
        },
        close: "إغلاق",
      },
      statusFilter: {
        title: "تصفية حسب الحالة",
        groups: "المجموعات",
        selected: "محدد",
      },
      flowBuilderConfig: {
        title: "صمم تدفقك",
        actions: {
          import: "استيراد",
          export: "تصدير",
          save: "حفظ"
        },
        messages: {
          flowStart: "بداية التدفق",
          interval: "فترة {{seconds}} ثانية",
          rememberSave: "لا تنسى حفظ تدفقك!",
          flowSaved: "تم حفظ التدفق بنجاح"
        },
        nodes: {
          start: "البداية",
          content: "المحتوى",
          menu: "القائمة",
          optionFormat: "[{{number}}] {{value}}",
          randomizer: "العشوائية",
          interval: "فترة",
          ticket: "التذكرة",
          typebot: "TypeBot",
          openai: "OpenAI",
          question: "سؤال",
          image: "صورة",
          video: "فيديو",
          audioNode: {
            title: "الصوت",
            recordedLive: "مسجل مباشرة",
            audioSent: "تم إرسال الصوت",
            browserNotSupported: "متصفحك لا يدعم HTML5"
          },
          kanbanPhase: "مرحلة كانبان",
          addTag: "إضافة علامة",
          noTag: "لا توجد علامة",
          noResponse: "بدون رد",
        },
        nodeDescriptions: {
          startFlow: "هذا البلوك يحدد بداية تدفقك!"
        },
        edges: {
          edgeWithoutOnDelete: "حافة بدون onDelete مكونة:",
          errorDeletingEdge: "خطأ في حذف الحافة:",
          removeEdgeTooltip: "إزالة الاتصال"
        },
        units: {
          seconds: "ثوانٍ"
        },
        validation: {
          tooShort: "قصير جداً!",
          tooLong: "طويل جداً!",
          enterName: "أدخل اسماً!",
          enterMessage: "أدخل رسالة!",
          required: "مطلوب",
          describeAiTraining: "صف التدريب للذكاء الاصطناعي",
          invalidModel: "نموذج غير صحيح",
          informModel: "أبلغ عن النموذج",
          minTokens: "10 رموز كحد أدنى",
          maxTokens: "4096 رمز كحد أقصى",
          informMaxTokens: "أبلغ عن العدد الأقصى للرموز",
          minZero: "0 كحد أدنى",
          maxOne: "1 كحد أقصى",
          informTemperature: "أبلغ عن درجة الحرارة",
          informApiKey: "أبلغ عن مفتاح API",
          minOneMessage: "رسالة واحدة كحد أدنى",
          maxFiftyMessages: "50 رسالة كحد أقصى",
          informMaxMessages: "أبلغ عن العدد الأقصى للرسائل",
          informVoiceMode: "أبلغ عن وضع الصوت"
        },
        buttons: {
          add: "إضافة",
          save: "حفظ",
          edit: "تحرير"
        },
        modals: {
          condition: {
            addTitle: "إضافة شرط إلى التدفق",
            editTitle: "تحرير الشرط",
            fieldLabel: "حقل الشرط (أدخل مفتاح واحد فقط)",
            validationRule: "قاعدة التحقق",
            conditionValue: "قيمة الشرط المراد تحليلها"
          },
          ticket: {
            addQueueError: "أضف طابور",
            addTitle: "إضافة طابور إلى التدفق",
            editTitle: "تحرير الطابور",
            selectConnection: "اختر طابورًا"
          },
          randomizer: {
            addIntervalError: "أضف قيمة الفاصل",
            maxTimeError: "تم الوصول إلى الحد الأقصى للوقت 120 ثانية",
            addTitle: "إضافة عشوائي إلى التدفق",
            editTitle: "تحرير العشوائي"
          },
          openai: {
            addTitle: "إضافة OpenAI/Gemini إلى التدفق",
            editTitle: "تحرير OpenAI/Gemini للتدفق"
          },
          question: {
            addTitle: "إضافة سؤال إلى التدفق",
            editTitle: "تحرير السؤال",
            createTitle: "إنشاء سؤال في التدفق",
            messageLabel: "الرسالة",
            saveAnswer: "حفظ الإجابة"
          }
        },
        models: {
          gpt35turbo: "GPT 3.5 Turbo",
          gpt4o: "GPT 4o",
          gemini15flash: "Gemini 1.5 Flash",
          gemini15pro: "Gemini 1.5 Pro",
          gemini20flash: "Gemini 2.0 Flash",
          gemini20pro: "Gemini 2.0 Pro"
        },
        voice: {
          text: "نص",
          francisca: "فرانسيسكا",
          antonio: "أنطونيو",
          brenda: "بريندا",
          donato: "دوناتو",
          elza: "إلزا",
          fabio: "فابيو",
          giovanna: "جيوفانا",
          humberto: "هومبيرتو",
          julio: "خوليو",
          leila: "ليلى",
          leticia: "ليتيسيا",
          manuela: "مانويلا",
          nicolau: "نيكولاو",
          valerio: "فاليريو",
          yara: "يارا"
        }
      },
      flowBuilderModals: {
        textModal: {
          titleAdd: "إضافة رسالة إلى التدفق",
          titleEdit: "تحرير رسالة التدفق",
          buttonAdd: "إضافة",
          buttonSave: "حفظ",
          fields: {
            message: "الرسالة"
          },
          validation: {
            tooShort: "قصير جداً!",
            tooLong: "طويل جداً!",
            required: "أدخل اسماً!",
            messageRequired: "أدخل رسالة!"
          }
        },
        intervalModal: {
          titleAdd: "إضافة فترة إلى التدفق",
          titleEdit: "تحرير الفترة",
          buttonAdd: "إضافة",
          buttonEdit: "تحرير",
          fields: {
            interval: "الفترة",
            timeInSeconds: "الوقت بالثواني",
            timeValue: "الوقت",
            unit: "الوحدة",
            unitSeconds: "ثوانٍ",
            unitMinutes: "دقائق",
            unitHours: "ساعات",
            unitDays: "أيام",
            businessHours: "ساعات العمل",
            businessHoursHelp: "سيتم إرسال الرسالة فقط خلال ساعات العمل المكونة",
            startTime: "البداية",
            endTime: "النهاية",
            daysOfWeek: "أيام الأسبوع",
            daySun: "الأحد",
            dayMon: "الاثنين",
            dayTue: "الثلاثاء",
            dayWed: "الأربعاء",
            dayThu: "الخميس",
            dayFri: "الجمعة",
            daySat: "السبت",
          },
          validation: {
            addValue: "أضف قيمة الفترة",
            maxTime: "تم الوصول إلى القيمة القصوى لهذه الوحدة",
            maxSeconds: "الحد الأقصى 120 ثانية",
            maxMinutes: "الحد الأقصى 120 دقيقة",
            maxHours: "الحد الأقصى 72 ساعة",
            maxDays: "الحد الأقصى 30 يومًا",
          },
          aiTimeout: {
            title: "مخرج الذكاء الاصطناعي (وقت تولي الذكاء الاصطناعي)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتولى الذكاء الاصطناعي المحادثة (المخرج البنفسجي)"
          }
        },
        menuModal: {
          titleAdd: "إضافة قائمة إلى التدفق",
          titleEdit: "تحرير القائمة",
          buttonAdd: "إضافة",
          buttonSave: "حفظ",
          fields: {
            explanationMessage: "رسالة شرح القائمة",
            addOption: "إضافة خيار",
            typeOption: "اكتب {{number}}",
            optionPlaceholder: "اكتب الخيار"
          },
          invalidOption: {
            title: "خيار غير صالح",
            messageLabel: "رسالة الخيار غير الصالح",
            placeholder: "مثال: خيار غير صالح. يرجى اختيار أحد الخيارات أدناه:",
            helperText: "إذا تم ملؤها، فعندما يرسل العميل شيئًا خارج الخيارات، سيتم إرسال هذه الرسالة وعرض القائمة مرة أخرى."
          },
          timeout: {
            title: "انتهاء المهلة (بدون رد)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتبع التدفق مسار انتهاء المهلة (المخرج البرتقالي)"
          },
          aiTimeout: {
            title: "مخرج الذكاء الاصطناعي (وقت تولي الذكاء الاصطناعي)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتولى الذكاء الاصطناعي المحادثة (المخرج البنفسجي)"
          }
        },
        singleBlockModal: {
          titleAdd: "إضافة محتوى إلى التدفق",
          titleEdit: "تحرير المحتوى",
          buttonAdd: "إضافة",
          buttonSave: "حفظ",
          elements: {
            text: "نص",
            interval: "فترة",
            image: "صورة",
            audio: "صوت",
            video: "فيديو",
            document: "مستند"
          },
          fields: {
            message: "الرسالة",
            timeInSeconds: "الوقت بالثواني",
            sendAsRecordedAudio: "إرسال كصوت مسجل",
            noFileSelected: "لم يتم اختيار ملف"
          },
          buttons: {
            sendImage: "إرسال صورة",
            sendAudio: "إرسال صوت",
            sendVideo: "إرسال فيديو",
            sendDocument: "إرسال مستند"
          },
          validation: {
            emptyMessageFields: "حقول الرسالة فارغة!",
            intervalValidation: "الفترة لا يمكن أن تكون 0 أو أكبر من 120!",
            fileTooLarge2MB: "الملف كبير جداً! الحد الأقصى 2 ميجابايت",
            fileTooLarge5MB: "الملف كبير جداً! الحد الأقصى 5 ميجابايت",
            fileTooLarge20MB: "الملف كبير جداً! الحد الأقصى 20 ميجابايت",
            fileTooLarge15MB: "الملف كبير جداً! الحد الأقصى 15 ميجابايت",
            deleteEmptyCards: "احذف البطاقات الفارغة أو أرسل الملفات المعلقة.",
            browserNotSupported: "متصفحك لا يدعم HTML5",
            onlyMp4Videos: "انتباه! فقط مقاطع فيديو MP4!",
            uploadError: "حدث خطأ أثناء معالجة الملف"
          },
          messages: {
            contentAddedSuccess: "تم إضافة المحتوى بنجاح!",
            uploadingFiles: "جاري رفع الملفات وإنشاء المحتوى...",
            variables: "المتغيرات"
          },
          timeout: {
            title: "انتهاء المهلة (بدون رد)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتبع التدفق مسار انتهاء المهلة (المخرج الأصفر)"
          },
          aiTimeout: {
            title: "مخرج الذكاء الاصطناعي (وقت تولي الذكاء الاصطناعي)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتولى الذكاء الاصطناعي المحادثة (المخرج البنفسجي)"
          },
          audioRecorder: {
            or: "أو",
            recordAudio: "تسجيل صوت",
            recording: "جارٍ التسجيل",
            paused: "متوقف مؤقتًا",
            recordingCompleted: "اكتمل التسجيل - {{time}}",
            discard: "تجاهل",
            useThisAudio: "استخدام هذا الصوت",
            cancel: "إلغاء",
            pause: "إيقاف مؤقت",
            resume: "متابعة",
            finish: "إنهاء",
            pausedHint: "استمع إلى المعاينة، تابع أو أنهِ التسجيل",
            recordingHint: "أوقف التسجيل مؤقتًا أو أنهِه",
            microphoneError: "تعذر الوصول إلى الميكروفون. تحقق من أذونات المتصفح."
          }
        },
        randomizerModal: {
          titleAdd: "إضافة عشوائية إلى التدفق",
          titleEdit: "تحرير العشوائية",
          title: "توزيع المخارج",
          sliderLabel: "نسبة العشوائية",
          outputsTitle: "كيف يعمل",
          outputsHint: "النسبة الأولى تتبع المخرج الأول؛ والباقي يتبع المخرج الثاني.",
          buttonAdd: "إضافة",
          buttonEdit: "تحرير"
        },
        ticketModal: {
          titleAdd: "إضافة طابور إلى التدفق",
          titleEdit: "تحرير الطابور",
          buttonAdd: "إضافة",
          buttonEdit: "تحرير",
          fields: {
            selectConnection: "اختر اتصال"
          },
          validation: {
            addQueue: "أضف طابور"
          }
        },
        typebotModal: {
          titleAdd: "إضافة Typebot إلى التدفق",
          titleEdit: "تحرير Typebot للتدفق",
          titleEditFlow: "تحرير Typebot للتدفق",
          buttonAdd: "إضافة",
          buttonSave: "حفظ"
        },
        openaiModal: {
          titleAdd: "إضافة OpenAI/Gemini إلى التدفق",
          titleEdit: "تحرير OpenAI/Gemini للتدفق",
          buttonAdd: "إضافة",
          buttonSave: "حفظ",
          models: {
            gpt35: "GPT 3.5 Turbo",
            gpt4o: "GPT 4o",
            gemini15flash: "Gemini 1.5 Flash",
            gemini15pro: "Gemini 1.5 Pro",
            gemini20flash: "Gemini 2.0 Flash",
            gemini20pro: "Gemini 2.0 Pro"
          },
          voices: {
            text: "نص",
            francisca: "فرانسيسكا",
            antonio: "أنطونيو",
            brenda: "بريندا",
            donato: "دوناتو",
            elza: "إلزا",
            fabio: "فابيو",
            giovanna: "جيوفانا",
            humberto: "هومبرتو",
            julio: "خوليو",
            leila: "ليلى",
            leticia: "ليتيسيا",
            manuela: "مانويلا",
            nicolau: "نيكولاو",
            valerio: "فاليريو",
            yara: "يارا"
          },
          validation: {
            tooShort: "قصير جداً!",
            tooLong: "طويل جداً!",
            required: "مطلوب",
            promptRequired: "وصف التدريب للذكاء الاصطناعي",
            invalidModel: "نموذج غير صالح",
            minTokens: "الحد الأدنى 10 رموز",
            maxTokens: "الحد الأقصى 4096 رمز",
            tokensRequired: "أخبر بالعدد الأقصى للرموز",
            temperatureRequired: "أخبر بدرجة الحرارة",
            temperatureMin: "الحد الأدنى 0",
            temperatureMax: "الحد الأقصى 1",
            apiKeyRequired: "أخبر بمفتاح API",
            messagesMin: "الحد الأدنى 1 رسالة",
            messagesMax: "الحد الأقصى 50 رسالة",
            messagesRequired: "أخبر بالعدد الأقصى للرسائل",
            voiceRequired: "أخبر بوضع الصوت"
          }
        },
        questionModal: {
          titleAdd: "إضافة سؤال إلى التدفق",
          titleEdit: "تحرير سؤال التدفق",
          titleCreate: "إنشاء سؤال في التدفق",
          buttonAdd: "إضافة",
          buttonSave: "حفظ",
          fields: {
            message: "الرسالة",
            saveAnswer: "حفظ الإجابة"
          },
          timeout: {
            title: "المهلة (بدون رد)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتابع التدفق عبر مسار المهلة (المخرج الأصفر)"
          },
          aiTimeout: {
            title: "مخرج الذكاء الاصطناعي (وقت تولي الذكاء الاصطناعي)",
            label: "الوقت بالثواني (0 = معطل)",
            helperText: "إذا لم يرد العميل خلال {{seconds}} ثانية، يتولى الذكاء الاصطناعي المحادثة (المخرج البنفسجي)"
          }
        }
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "الرقم",
          body: "الرسالة",
          token: "الرمز المسجل",
          userId: "معرف المستخدم/الوكيل",
          queueId: "معرف الطابور",
        },
        mediaMessage: {
          number: "الرقم",
          body: "اسم الملف",
          media: "الملف",
          token: "الرمز المسجل",
        },
        API: {
          title: "توثيق إرسال الرسائل",
          methods: {
            title: "طرق الإرسال",
            messagesText: "الرسائل النصية",
            messagesMidia: "رسائل الوسائط",
          },
          instructions: {
            title: "التعليمات",
            comments: "ملاحظات مهمة",
            comments1:
              "قبل إرسال الرسائل، من الضروري تسجيل الرمز المرتبط بالاتصال الذي سيرسل الرسائل. <br />للتسجيل، انتقل إلى قائمة 'الاتصالات'، انقر على زر تحرير الاتصال وأدخل الرمز في الحقل المناسب.",
            comments2:
              "رقم الإرسال يجب ألا يحتوي على أقنعة أو أحرف خاصة ويجب أن يتكون من:",
            codeCountry: "كود البلد",
            code: "كود المنطقة",
            number: "الرقم",
          },
          text: {
            title: "1. الرسائل النصية",
            instructions:
              "فيما يلي قائمة بالمعلومات المطلوبة لإرسال الرسائل النصية:",
          },
          media: {
            title: "2. رسائل الوسائط",
            instructions:
              "فيما يلي قائمة بالمعلومات المطلوبة لإرسال رسائل الوسائط:",
          },
        },
        messages: {
          noPermission: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة! نحن نقوم بإعادة توجيهك.",
          success: "تم إرسال الرسالة بنجاح",
        },
        form: {
          send: "إرسال",
          testSend: "اختبار الإرسال",
        },
        documentation: {
          endpoint: "نقطة النهاية: ",
          method: "الطريقة: ",
          post: "POST",
          headers: "الرؤوس: ",
          headersTextAuth: "Authorization Bearer (الرمز المسجل) و Content-Type (application/json)",
          headersMediaAuth: "Authorization Bearer (الرمز المسجل) و Content-Type (multipart/form-data)",
          body: "الجسم: ",
          formData: "FormData: ",
          bodyExample: "{\n  \"number\": \"558599999999\",\n  \"body\": \"Message\",\n  \"userId\": \"معرف المستخدم أو \\\"\\\"\",\n  \"queueId\": \"معرف الطابور أو \\\"\\\"\",\n  \"sendSignature\": \"توقيع الرسالة - true/false\",\n  \"closeTicket\": \"إغلاق التذكرة - true/false\"\n}",
          formDataFields: {
            number: "number: 558599999999",
            body: "body: Message",
            userId: "userId: معرف المستخدم أو \\\"\\\"",
            queueId: "queueId: معرف الطابور أو \\\"\\\"",
            medias: "medias: ملف",
            sendSignature: "sendSignature: توقيع الرسالة true/false",
            closeTicket: "closeTicket: إغلاق التذكرة true/false",
          },
        },
      },
      plans: {
        title: "الخطط",
        subtitle: "إدارة الخطط المتاحة على المنصة",
        actions: {
          new: "خطة جديدة",
        },
        empty: {
          search: "لا توجد خطة تطابق البحث.",
          list: "لا توجد خطط مسجلة.",
        },
        table: {
          actions: "الإجراءات",
        },
        modal: {
          createTitle: "خطة جديدة",
          editTitle: "تعديل الخطة",
          cancel: "إلغاء",
          billingType: "نوع الفوترة",
          billingTypes: {
            single: "مرة واحدة",
            recurring: "متكرر",
            free: "مجاني",
          },
          recurrence: "التكرار",
          recurrences: {
            weekly: "أسبوعي",
            biweekly: "نصف شهري",
            monthly: "شهري",
            quarterly: "ربع سنوي",
            semiannual: "نصف سنوي",
            annual: "سنوي",
          },
          resources: "الموارد",
          markAll: "تحديد الكل",
          unmarkAll: "إلغاء تحديد الكل",
        },
        form: {
          name: "الاسم",
          users: "المستخدمون",
          connections: "الاتصالات",
          campaigns: "الحملات",
          schedules: "الجداول",
          enabled: "مفعّل",
          disabled: "معطّل",
          clear: "إلغاء",
          delete: "حذف",
          save: "حفظ",
          yes: "نعم",
          no: "لا",
          money: "$",
          public: "عام",
        },
      },
      helps: {
        title: "مركز المساعدة",
        thumbnail: "صورة مصغرة",
        videoPlayerTitle: "مشغل فيديو YouTube",
        settings: {
          codeVideo: "كود الفيديو",
          description: "الوصف",
          clear: "مسح",
          delete: "حذف",
          save: "حفظ",
        },
      },
      moments: {
        title: "لوحة الوقت الفعلي",
        subtitle: "الخدمات المباشرة مجمعة حسب الوكيل",
        pending: "في الانتظار",
        attendances: "الحضور: ",
        noQueue: "لا يوجد طابور",
        accessTicket: "الوصول إلى التذكرة",
        refresh: "تحديث",
        empty: "لا توجد خدمات نشطة في الوقت الحالي.",
        noTickets: "لا توجد خدمات نشطة",
        ticketSingular: "خدمة",
        ticketsPlural: "خدمات",
        unread: "غير مقروءة",
        kpis: {
          online: "الوكلاء المتصلون",
          active: "في الخدمة",
          pending: "في الانتظار",
          top: "أفضل وكيل",
        },
      },
      colorBoxModal: {
        title: "اختر لونًا",
        eyeDropper: "التقط اللون من الشاشة",
        buttons: {
          cancel: "إلغاء",
          ok: "موافق",
        },
        tooltips: {
          copy: "نسخ اللون",
          copied: "تم النسخ!",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "إضافة مشروع",
          edit: "تحرير المشروع",
        },
        info: {
          intro: {
            title: "ⓘ ما هي تكاملات التدفق",
            text: "تربط التكاملات هذه المنصة بأنظمة الأتمتة الخارجية:<ul><li><strong>N8N:</strong> منسق سير عمل مرئي — تنشئ أتمتة بمشغلات وشروط وإجراءات تُفعّل في كل رسالة مستلمة.</li><li><strong>Typebot:</strong> أداة بناء روبوتات محادثة — يتحدث العميل مع تدفق موجه من أسئلة وإجابات محددة مسبقاً.</li></ul><strong>كيف يعمل:</strong> عند استلام رسالة، يرسل النظام البيانات إلى عنوان URL المُكوَّن ويعالج الاستجابة المُرجَعة. يتم اختيار التكامل لكل اتصال في علامة التبويب <em>التكاملات</em> في الواتساب."
          }
        },
        sections: {
          type: "نوع التكامل",
          typeDesc: "اختر الخدمة الخارجية التي ستعالج الرسائل.",
          n8nConfig: "إعدادات N8N",
          n8nConfigDesc: "قدم اسماً لتحديد هذا التكامل وعنوان webhook الذي سيستلم الأحداث.",
          typebotConnection: "اتصال Typebot",
          typebotConnectionDesc: "حدد التكامل وقدم الخادم + slug للبوت المنشور في Typebot.",
          typebotBehavior: "سلوك المحادثة",
          typebotBehaviorDesc: "يتحكم بوقت انتهاء الصلاحية والتأخير بين الرسائل والكلمات المفتاحية التي تُغلق أو تعيد تشغيل البوت."
        },
        help: {
          name: "اسم داخلي لتحديد هذا التكامل في القائمة (مثال: 'بوت دعم N8N').",
          urlN8N: "عنوان webhook الكامل لتدفق عمل N8N الخاص بك. اعثر عليه في: عقدة Webhook → 'Production URL'. يجب أن يكون متاحاً للوصول العام من قبل خلفية هذه المنصة.",
          urlTypebot: "عنوان URL الأساسي لخادم Typebot (مثال: 'https://typebot.io' للنسخة الرسمية أو نطاق مثيلك المستضاف ذاتياً).",
          typebotSlug: "المعرف العام للبوت المنشور. اعثر عليه في علامة تبويب Share في Typebot — هو الجزء الأخير من العنوان (مثال: 'my-bot-123').",
          typebotExpires: "الوقت (بالساعات) الذي تظل جلسة البوت نشطة فيه دون رسالة جديدة من جهة الاتصال. بعد هذه الفترة، يُعاد تشغيل التدفق. استخدم 0 لعدم انتهاء الصلاحية أبداً.",
          typebotDelayMessage: "الوقت (بالـ ms) الذي ينتظره البوت قبل إرسال كل استجابة. يحاكي الكتابة البشرية. الموصى به: 1000-2000ms.",
          typebotKeywordFinish: "الكلمة التي، عند إرسالها من قبل العميل، تُنهي تدفق البوت فوراً وتفتح الخدمة البشرية (مثال: 'خروج'، 'موظف').",
          typebotKeywordRestart: "الكلمة التي تعيد تشغيل تدفق البوت من البداية (مثال: 'إعادة'، 'قائمة'). يعود العميل إلى السؤال الأول من Typebot.",
          typebotUnknownMessage: "الرسالة التي يرسلها البوت عندما يستلم استجابة لا يفهمها أو لا تتطابق مع أي خيار من خيارات التدفق (مثال: 'لم أفهم، هل يمكنك إعادة الصياغة؟').",
          typebotRestartMessage: "الرسالة المرسلة تلقائياً عند إعادة تشغيل التدفق بالكلمة المفتاحية أعلاه (مثال: 'لنبدأ من جديد!')."
        },
        form: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          jsonContent: "محتوى Json",
          urlN8N: "الرابط",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "الوقت بالدقائق لانتهاء صلاحية المحادثة",
          typebotKeywordFinish: "كلمة إنهاء التذكرة",
          typebotKeywordRestart: "كلمة إعادة تشغيل التدفق",
          typebotRestartMessage: "رسالة إعادة تشغيل المحادثة",
          typebotUnknownMessage: "رسالة الخيار غير الصالح",
          typebotDelayMessage: "الفاصل الزمني (ms) بين الرسائل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          test: "اختبار البوت",
        },
        languages: {
          "pt-BR": "البرتغالية",
          "en": "الإنجليزية",
          "es": "الإسبانية",
        },
        messages: {
          testSuccess: "تم اختبار التكامل بنجاح!",
          addSuccess: "تم إضافة التكامل بنجاح.",
          editSuccess: "تم تحرير التكامل بنجاح.",
        },
      },
      queueIntegration: {
        title: "التكاملات",
        subtitle: "اربط التدفقات الآلية الخارجية مثل N8N و Typebot",
        empty: "لا توجد تكاملات مسجلة.",
        table: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
        },
        buttons: {
          add: "إضافة مشروع",
          edit: "تعديل",
          delete: "حذف",
        },
        searchPlaceholder: "بحث...",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ هذا الإجراء لا يمكن التراجع عنه! وسيتم إزالته من الطوابير والاتصالات المرتبطة",
        },
        toasts: {
          deleted: "تم حذف التكامل بنجاح!",
        },
        messages: {
          noPermission: "هذه الشركة ليس لديها إذن للوصول إلى هذه الصفحة! نحن نقوم بإعادة توجيهك.",
        },
      },
      queueModal: {
        title: {
          queueData: "بيانات الطابور",
          text: "ساعات العمل",
          add: "إضافة طابور",
          edit: "تعديل الطابور",
          confirmationDelete: "هل أنت متأكد؟ سيتم حذف جميع خيارات التكامل."
        },
        info: {
          intro: {
            title: "ⓘ ما هو الطابور",
            text: "<strong>الطوابير</strong> (الأقسام) تنظم الخدمة. يمكن ربط كل اتصال بطابور واحد أو أكثر، ويرى الموظفون فقط تذاكر الطوابير التي هم أعضاء فيها.<ul><li>حدد <strong>الاسم</strong> و<strong>اللون</strong> لتحديد الطابور بصرياً.</li><li>تُرسل <strong>رسالة الترحيب</strong> عندما يدخل العميل هذا الطابور.</li><li><strong>المُوجّه</strong> يوزع التذاكر تلقائياً بين الموظفين المتصلين.</li></ul><strong>للأتمتة المتقدمة</strong>، استخدم <em>FlowBuilder</em> واختر التدفق في اتصال واتساب."
          }
        },
        sections: {
          identity: "التعريف",
          identityDesc: "اسم ولون وترتيب عرض الطابور.",
          behavior: "السلوك",
          behaviorDesc: "يحدد الإجراءات التلقائية عندما تدخل التذكرة أو يتم تعيينها لهذا الطابور.",
          messages: "الرسائل التلقائية",
          messagesDesc: "نصوص ترسل تلقائياً في لحظات محددة من الخدمة."
        },
        help: {
          name: "الاسم الداخلي للطابور. يظهر في القوائم والتقارير. استخدم شيئاً وصفياً (مثال: 'دعم'، 'مبيعات BR').",
          color: "لون العلامة المرئية للطابور. يظهر في قوائم التذاكر والمحادثة والتقارير.",
          orderQueue: "الموقع الرقمي لهذا الطابور في قوائم الروبوت. تظهر الطوابير ذات الأرقام الأقل أولاً. استخدم 0 للإخفاء.",
          closeTicket: "عند التفعيل، تُغلق التذكرة تلقائياً في نهاية تدفق الروبوت. مفيد للأسئلة الشائعة والخدمة الآلية بنسبة 100٪.",
          rotate: "الموجه التلقائي: يعيد توزيع التذاكر دون موظف مُعيَّن بين الموظفين المتصلين في الطابور كل X دقيقة.",
          tempoRoteador: "الفاصل الزمني (بالدقائق) بين كل إعادة توزيع تلقائية. الموصى به: 5 إلى 10 دقائق.",
          greetingMessage: "النص المرسل إلى العميل عندما تدخل التذكرة هذا الطابور. يمكن أن يتضمن متغيرات مثل {{name}} (اسم جهة الاتصال) و {{queue}}."
        },
        form: {
          name: "الاسم",
          color: "اللون",
          orderQueue: "ترتيب الطابور (روبوت)",
          greetingMessage: "رسالة الترحيب",
          closeTicket: "إغلاق التذكرة",
          rotate: "تنشيط الموجه",
          timeRotate: "وقت التوجيه (دقائق)",
          timeOptions: {
            minutes2: "دقيقتان",
            minutes5: "5 دقائق",
            minutes10: "10 دقائق",
            minutes15: "15 دقيقة",
            minutes30: "30 دقيقة",
            minutes45: "45 دقيقة",
            minutes60: "60 دقيقة"
          }
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء"
        },
        validations: {
          tooShort: "قصير جداً!",
          tooLong: "طويل جداً!",
          required: "مطلوب"
        },
        serviceHours: {
          monday: "الإثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
          sunday: "الأحد"
        }
      },
      queues: {
        title: "الطوابير",
        subtitle: "أقسام لتنظيم وتوزيع التذاكر بين الموظفين",
        empty: "لا توجد طوابير مسجلة.",
        table: {
          name: "الاسم",
          color: "اللون",
          greeting: "رسالة الترحيب",
          orderQueue: "ترتيب الطابور (روبوت)",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة طابور",
          edit: "تعديل",
          delete: "حذف",
        },
        toasts: {
          success: "تم حفظ الطابور بنجاح",
          deleted: "تم حذف الطابور بنجاح",
          queueDeleted: "تم حذف الطابور بنجاح!",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ هذا الإجراء لا يمكن التراجع عنه! ستظل خدمات هذا الطابور موجودة، لكن لن يتم تخصيص أي طابور لها.",
        },
      },
      quickMessages: {
        title: "الردود السريعة",
        subtitle: "اختصارات للرسائل القابلة لإعادة الاستخدام في الخدمة",
        searchPlaceholder: "بحث...",
        noAttachment: "لا يوجد مرفق",
        empty: "لا توجد ردود سريعة مسجلة.",
        global: "عام",
        personal: "شخصي",
        kpis: {
          total: "الإجمالي",
          withMedia: "مع وسائط",
          global: "عامة",
          personal: "شخصية",
        },
        filters: {
          visibility: "الرؤية",
          all: "الكل",
          mine: "خاصة بي",
          shared: "مشتركة",
        },
        tooltips: {
          edit: "تعديل",
          delete: "حذف",
          removeAttachment: "إزالة المرفق",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه! هل تريد المتابعة؟",
        },
        buttons: {
          add: "إضافة",
          attach: "إرفاق ملف",
          cancel: "إلغاء",
          edit: "تعديل",
        },
        toasts: {
          success: "تم إضافة الاختصار بنجاح!",
          deleted: "تم حذف الاختصار بنجاح!",
        },
        dialog: {
          title: "رسالة سريعة",
          shortcode: "اختصار",
          message: "الرد",
          save: "حفظ",
          cancel: "إلغاء",
          geral: "السماح بالتعديل",
          add: "إضافة",
          edit: "تعديل",
          visao: "السماح بالعرض",
          allow: "السماح",
          disallow: "عدم السماح",
        },
        table: {
          shortcode: "اختصار",
          message: "الرسالة",
          actions: "الإجراءات",
          mediaName: "اسم الملف",
          status: "النطاق",
          createdBy: "أنشأها",
          you: "أنت",
          emptyMessage: "—",
        },
      },
      announcements: {
        title: "الإعلانات",
        subtitle: "إدارة الإعلانات المعروضة لمستخدمي المنصة.",
        searchPlaceholder: "بحث",
        active: "نشط",
        inactive: "غير نشط",
        buttons: {
          add: "إعلان جديد",
          contactLists: "قوائم الإعلانات",
        },
        table: {
          priority: "الأولوية",
          title: "العنوان",
          text: "النص",
          mediaName: "الملف",
          status: "الحالة",
          actions: "الإجراءات",
        },
        dialog: {
          title: "إضافة إعلان",
          titleField: "العنوان",
          message: "النص",
          save: "حفظ",
          cancel: "إلغاء",
        },
        toasts: {
          success: "تم إنشاء الإعلان بنجاح!",
          deleted: "تم حذف الإعلان بنجاح!",
        },
        confirmationModal: {
          deleteTitle: "حذف الإعلان",
          deleteMessage: "هل أنت متأكد من رغبتك في حذف هذا الإعلان؟",
        },
      },
      scheduleModal: {
        title: {
          add: "موعد جديد",
          edit: "تحرير الموعد",
        },
        form: {
          body: "الرسالة",
          contact: "جهة الاتصال",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          assinar: "إرسال التوقيع"
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addSchedule: "إضافة موعد"
        },
        success: "تم حفظ الموعد بنجاح.",
        validations: {
          tooShort: "الرسالة قصيرة جداً",
          required: "مطلوب"
        },
        toasts: {
          deleted: "تم حذف الوسائط بنجاح."
        },
        confirmationModal: {
          deleteTitle: "حذف الوسائط",
          deleteMessage: "هل أنت متأكد من أنك تريد حذف هذه الوسائط؟"
        },
        status: {
          sending: "جاري الإرسال",
          pending: "في الانتظار",
          sent: "تم الإرسال",
          error: "خطأ في الإرسال"
        },
        recurrence: {
          title: "التكرار",
          description: "يمكنك اختيار إرسال الرسالة بشكل متكرر واختيار الفترة الزمنية. إذا كانت رسالة لمرة واحدة، فلا تغير شيئاً في هذا القسم.",
          interval: "الفترة",
          intervalValue: "قيمة الفترة",
          sendTimes: "إرسال كم مرة",
          intervalTypes: {
            days: "أيام",
            weeks: "أسابيع",
            months: "شهور",
            minutes: "دقائق"
          },
          businessDays: {
            normal: "إرسال بشكل عادي في الأيام غير العمل",
            before: "إرسال يوم عمل قبل",
            after: "إرسال يوم عمل بعد"
          }
        },
        calendar: {
          messages: {
            date: "التاريخ",
            time: "الوقت",
            event: "الحدث",
            allDay: "طوال اليوم",
            week: "الأسبوع",
            work_week: "المواعيد",
            day: "اليوم",
            month: "الشهر",
            previous: "السابق",
            next: "التالي",
            yesterday: "أمس",
            tomorrow: "غداً",
            today: "اليوم",
            agenda: "جدول الأعمال",
            noEventsInRange: "لا توجد مواعيد في الفترة.",
            showMore: "المزيد"
          }
        },
        permissions: {
          noAccess: "هذه الشركة ليس لديها إذن للوصول إلى هذه الصفحة! نحن نعيد توجيهك."
        }
      },
      contactDrawer: {
        header: "بيانات جهة الاتصال",
        buttons: {
          edit: "تحرير جهة الاتصال",
          block: "حظر",
          unblock: "إلغاء الحظر",
          blockContact: "حظر جهة الاتصال",
          unblockContact: "إلغاء حظر جهة الاتصال",
        },
        toasts: {
          contactBlocked: "تم حظر جهة الاتصال",
          contactUnblocked: "تم إلغاء حظر جهة الاتصال",
        },
        confirmationModal: {
          blockMessage: "هل تريد حقاً حظر جهة الاتصال هذه؟ لن تتلقى المزيد من الرسائل منها.",
          unblockMessage: "هل تريد حقاً إلغاء حظر جهة الاتصال هذه؟ ستتمكن من البدء في تلقي الرسائل منها.",
        },
        extraInfo: "معلومات أخرى",
      },
      messageVariablesPicker: {
        label: "المتغيرات المتاحة",
        vars: {
          contactFirstName: "الاسم الأول",
          contactName: "الاسم",
          user: "المستخدم",
          greeting: "التحية",
          protocolNumber: "البروتوكول",
          date: "التاريخ",
          hour: "الساعة",
          ticket_id: "رقم التذكرة",
          queue: "القطاع",
          connection: "الاتصال",
        },
      },
      settings: {
        LGPD: {
          title: "LGPD",
          welcome: "رسالة ترحيب (LGPD)",
          linkLGPD: "رابط سياسة الخصوصية",
          obfuscateMessageDelete: "إخفاء الرسالة المحذوفة",
          alwaysConsent: "طلب الموافقة دائماً",
          obfuscatePhoneUser: "إخفاء رقم الهاتف للمستخدمين",
          enabled: "مُفعل",
          disabled: "غير مُفعل",
        },
        tabs: {
          schedules: "الجداول",
          companies: "الشركات",
          whitelabel: "العلامة البيضاء",
        },
        toasts: {
          schedulesSavedSuccess: "تم تحديث المواعيد بنجاح.",
          operationUpdatedSuccess: "تم تحديث العملية بنجاح.",
          recordsLoadError: "تعذر تحميل قائمة السجلات",
          operationSuccess: "تمت العملية بنجاح!",
          operationError: "تعذر تنفيذ العملية. تحقق من عدم وجود سجل بنفس الاسم أو من ملء جميع الحقول بشكل صحيح",
          operationDeleteError: "تعذر تنفيذ العملية",
          imageUploadProgress: "تم تحميل الصورة بنسبة {{progress}}%...",
          imageUploadError: "حدثت مشكلة في تحميل الصورة.",
          companyOperationError: "تعذر تنفيذ العملية. تحقق من عدم وجود شركة بنفس الاسم أو من ملء جميع الحقول بشكل صحيح",
          planOperationError: "تعذر تنفيذ العملية. تحقق من عدم وجود خطة بنفس الاسم أو من ملء جميع الحقول بشكل صحيح",
          helpOperationError: "تعذر تنفيذ العملية. تحقق من عدم وجود مساعدة بنفس الاسم أو من ملء جميع الحقول بشكل صحيح",
        },
        whitelabel: {
          primaryColorLight: "اللون الأساسي للوضع الفاتح",
          primaryColorDark: "اللون الأساسي للوضع الداكن",
          sidebarTextColorLight: "لون نصوص وأيقونات الشريط الجانبي في الوضع الفاتح",
          sidebarTextColorDark: "لون نصوص وأيقونات الشريط الجانبي في الوضع الداكن",
          systemName: "اسم النظام",
          lightLogo: "الشعار الفاتح",
          darkLogo: "الشعار الداكن",
          sidebarLightLogo: "شعار الشريط الجانبي في الوضع الفاتح",
          sidebarDarkLogo: "شعار الشريط الجانبي في الوضع الداكن",
          loginLightLogo: "شعار تسجيل الدخول في الوضع الفاتح",
          loginDarkLogo: "شعار تسجيل الدخول في الوضع الداكن",
          sidebarIconLight: "أيقونة الشريط الجانبي المغلق في الوضع الفاتح",
          sidebarIconDark: "أيقونة الشريط الجانبي المغلق في الوضع الداكن",
          favicon: "أيقونة المفضلة",
        },
        chatBotType: {
          text: "نص",
        },
        modals: {
          deleteTitle: "حذف السجل",
          deleteConfirmation: "هل تريد حقاً حذف هذا السجل؟",
        },
        managers: {
          common: {
            yes: "نعم",
            no: "لا",
          },
          companies: {
            recurrence: "التكرار",
          },
          plans: {
            queues: "القوائم",
            value: "القيمة",
            whatsapp: "واتساب",
            facebook: "فيسبوك",
            instagram: "إنستغرام",
            internalChat: "المحادثة الداخلية",
            externalAPI: "API خارجي",
            kanban: "كانبان",
            talkAI: "المطالبات",
            officialAPI: "API الرسمي",
            integrations: "التكاملات",
          },
          helps: {
            title: "العنوان",
            video: "فيديو",
          },
        },
      },
      flowBuilderNodes: {
        message: "الرسالة",
        condition: "الشرط",
        image: "الصورة"
      },
      subscription: {
        title: "الاشتراك",
        form: {
          licenseLabel: "فترة الترخيص",
          licenseExpiresIn: "ترخيصك ينتهي خلال {{days}} أيام!",
          licenseExpiresToday: "ترخيصك ينتهي اليوم!",
          billingEmailLabel: "بريد الفواتير الإلكتروني",
          subscribeButton: "اشترك الآن!"
        },
        checkout: {
          form: {
            fullName: "الاسم الكامل*",
            fullNameRequired: "الاسم الكامل مطلوب",
            lastName: "الاسم الأخير*",
            lastNameRequired: "الاسم الأخير مطلوب",
            address: "العنوان*",
            addressRequired: "العنوان مطلوب",
            city: "المدينة*",
            cityRequired: "المدينة مطلوبة",
            state: "الولاية*",
            stateRequired: "الولاية مطلوبة",
            document: "الرقم الضريبي*",
            documentRequired: "الرقم الضريبي مطلوب",
            documentInvalid: "تنسيق الرقم الضريبي غير صحيح",
            country: "البلد*",
            countryRequired: "البلد مطلوب",
            useAddressForPayment: "استخدم هذا العنوان لتفاصيل الدفع",
            nameOnCard: "الاسم على البطاقة*",
            nameOnCardRequired: "الاسم على البطاقة مطلوب",
            cardNumber: "رقم البطاقة*",
            cardNumberRequired: "رقم البطاقة مطلوب",
            cardNumberInvalid: "رقم البطاقة غير صحيح (مثال 4111111111111)",
            expiryDate: "تاريخ انتهاء الصلاحية*",
            expiryDateRequired: "تاريخ انتهاء الصلاحية مطلوب",
            expiryDateInvalid: "تاريخ انتهاء الصلاحية غير صحيح",
            cvv: "CVV*",
            cvvRequired: "CVV مطلوب",
            cvvInvalid: "CVV غير صحيح (مثال 357)"
          }
        }
      },
      ticketsResponsive: {
        actions: {
          selectTicket: "اختيار التذكرة",
          transferTicket: "نقل التذكرة",
          spyConversation: "تتبع المحادثة"
        },
        tabs: {
          ticket: "التذكرة",
          assistance: "المساعدة"
        },
        search: {
          searchInMessagesTooltip: "ضع علامة للبحث في محتويات الرسائل أيضاً (أبطأ)"
        },
        filter: {
          all: "الكل",
          unreplied: "بدون رد",
          title: "الفلاتر",
          queues: "قوائم الانتظار",
          tags: "الوسوم",
          connections: "الاتصالات",
          status: "الحالة",
          users: "المستخدمون",
          showTags: "إظهار الوسوم",
          hideTags: "إخفاء الوسوم"
        },
        sort: {
          ascending: "تصاعدي",
          descending: "تنازلي"
        },
        dialog: {
          spyingConversation: "تتبع المحادثة",
          loadingMessages: "جاري تحميل الرسائل..."
        },
        status: {
          noQueue: "لا يوجد طابور"
        }
      },
      messagesResponsive: {
        types: {
          location: "الموقع",
          contact: "جهة الاتصال"
        },
        actions: {
          download: "تنزيل",
          dropFileHere: "اسحب الملف هنا"
        },
        status: {
          forwarded: "محولة",
          deletedByContact: "🚫 تم حذف هذه الرسالة من قبل جهة الاتصال",
          deletedMessage: "🚫 _رسالة محذوفة_",
          deletedByMe: "🚫 تم حذف هذه الرسالة",
          edited: "محررة"
        },
        reactions: {
          youReacted: "تفاعلت...",
          contactReacted: " تفاعل... "
        },
        timestamp: {
          today: "اليوم"
        },
        placeholder: {
          sayHello: "قل مرحباً لجهة الاتصال الجديدة!"
        },
        ads: {
          adClick: "نقرة إعلان",
          defaultUserMessage: "مرحباً! أنا مهتم وأرغب في المزيد من المعلومات، من فضلك."
        },
        warnings: {
          facebookPolicy: "لديك 24 ساعة للرد بعد استلام رسالة، وفقاً لسياسات فيسبوك."
        }
      },
      messageInputResponsive: {
        type: {
          document: "مستند",
          buttons: "أزرار"
        },
        tooltip: {
          toggleSignature: "تفعيل/إلغاء التوقيع",
          toggleComments: "تفعيل/إلغاء التعليقات"
        },
        privateMessage: {
          suffix: "رسالة خاصة"
        }
      },
      tagsResponsive: {
        validation: {
          tooShort: "العلامة قصيرة جداً!"
        },
        placeholder: "العلامات"
      },
      tickets: {
        buttons: {
          showAll: "الكل",
          returnQueue: "العودة إلى الطابور",
          scredule: "موعد",
          deleteTicket: "حذف التذكرة",
          quickMessageFlash: "ردود سريعة",
        },
        noContactName: "(لا يوجد جهة اتصال)",
        noDepartment: "لا يوجد قسم",
        group: "مجموعة",
        transferTooltip: "نقل التذكرة",
        closedTicket: {
          closedMessage: "إغلاق التذكرة مع رسالة وداع",
          closedNotMessage: "إغلاق التذكرة بدون رسالة وداع",
        },
      },
      messages: {
        download: "تنزيل",
        today: "اليوم",
        contact: "جهة الاتصال",
        forwarded: "مُعاد توجيهه",
        deletedByContact: "🚫 تم حذف هذه الرسالة بواسطة جهة الاتصال &nbsp;",
        deletedMessage: "🚫 _رسالة محذوفة_ ",
        deletedBySender: "🚫 تم حذف هذه الرسالة &nbsp;",
        youReacted: "لقد تفاعلت... ",
        sayHello: "قل مرحباً لجهة الاتصال الجديدة!",
        dropFile: "اسحب الملف هنا",
        facebookPolicy: "لديك 24 ساعة للرد بعد تلقي رسالة، وفقاً لسياسات فيسبوك.",
        defaultMetaMessage: "مرحباً! أنا مهتم وأرغب في مزيد من المعلومات، من فضلك.",
      },
      ticketsResponsive: {
        search: {
          searchInMessagesTooltip: "ضع علامة للبحث أيضاً في محتويات الرسائل (أبطأ)",
        },
        filter: {
          all: "الكل",
          unreplied: "بدون رد",
          title: "الفلاتر",
          queues: "قوائم الانتظار",
          tags: "الوسوم",
          connections: "الاتصالات",
          status: "الحالة",
          users: "المستخدمون",
        },
        sort: {
          ascending: "تصاعدي",
          descending: "تنازلي",
        },
      },
      contactForm: {
        validation: {
          tooShort: "قصير جداً!",
          tooLong: "طويل جداً!",
          required: "مطلوب",
          invalidEmail: "بريد إلكتروني غير صحيح",
        },
        placeholders: {
          number: "5513912344321",
          email: "عنوان البريد الإلكتروني",
        },
      },
      common: {
        image: "صورة",
      },
      messageInputResponsive: {
        privateMessage: {
          suffix: "رسالة خاصة",
        },
        type: {
          document: "مستند",
          buttons: "أزرار",
        },
        tooltip: {
          toggleSignature: "تفعيل/إلغاء التوقيع",
          toggleComments: "تفعيل/إلغاء التعليقات",
        },
      },
      showTicketOpenModal: {
        buttons: {
          close: "إغلاق"
        }
      },
      reactions: {
        successMessage: "تم إرسال التفاعل بنجاح"
      },
      vcardPreview: {
        chatButton: "محادثة"
      },
      locationPreview: {
        viewButton: "عرض"
      },
      contactNotes: {
        addedSuccess: "تم إضافة الملاحظة بنجاح!",
        deletedSuccess: "تم حذف الملاحظة بنجاح!",
        deleteTitle: "حذف السجل",
        deleteConfirmation: "هل تريد حقاً حذف هذا السجل؟",
        cancelButton: "إلغاء",
        saveButton: "حفظ"
      },
      users: {
        title: "المستخدمون",
        subtitle: "إدارة موظفي فريقك وملفاتهم الشخصية وأذوناتهم",
        empty: "لا يوجد مستخدمون مسجلون.",
        table: {
          status: "الحالة",
          avatar: "الصورة الشخصية",
          name: "الاسم",
          email: "البريد الإلكتروني",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        profile: {
          admin: "مدير",
          user: "مستخدم",
        },
        status: {
          enabled: "مفعل",
          disabled: "معطل",
        },
        upload: {
          avatar: "تحميل الصورة الشخصية",
        },
        buttons: {
          add: "إضافة مستخدم",
          edit: "تعديل",
          delete: "حذف",
        },
        toasts: {
          deleted: "تم حذف المستخدم بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "سيتم فقدان جميع بيانات المستخدم. ستتم حركة الطلبات المفتوحة لهذا المستخدم إلى الطابور.",
        },
      },
      settings: {
        success: "تم حفظ الإعدادات بنجاح.",
        title: "الإعدادات",
        tabs: {
          options: "عام",
          schedules: "الجداول",
          companies: "الشركات",
          plans: "الخطط",
          helps: "المساعدة",
          whitelabel: "العلامة البيضاء",
          timezone: "المنطقة الزمنية",
          smtp: "البريد / SMTP",
          meta: "Meta",
        },
        settingsConfig: {
          options: {
            enableLGPD: "تفعيل التعامل مع GDPR",
            updating: "جاري التحديث...",
            autoTranslate: "الترجمة التلقائية للرسائل",
            translateApiKey: "مفتاح OpenAI API (للترجمة)",
            translateApiKeyHelper: "مفتاح OpenAI API للترجمة التلقائية. إذا كان فارغاً، يتم استخدام مفتاح أول Prompt مُكوّن.",
            aiAutoSummary: "ملخص الذكاء الاصطناعي اليومي التلقائي",
            aiSummaryApiKey: "مفتاح OpenAI API (لملخص الذكاء الاصطناعي)",
            aiSummaryApiKeyHelper: "مفتاح يُستخدم فقط لملخصات الذكاء الاصطناعي. إذا كان فارغاً، يتم استخدام مفتاح الترجمة أو مفتاح أول Prompt مُكوّن.",
            aiAutoSummaryTime: "وقت ملخص الذكاء الاصطناعي اليومي",
            aiAutoSummaryTimeHelper: "الوقت الذي سيتم فيه إنشاء الملخص التلقائي لجميع التذاكر المفتوحة.",
            flowbuilderAISectionTitle: "مخرج الذكاء الاصطناعي في FlowBuilder",
            flowbuilderAISectionDescription: "عند التفعيل، يستخدم \"مخرج الذكاء الاصطناعي\" في كتل FlowBuilder نموذج GPT لقراءة سجل المحادثة وتولي الخدمة تلقائياً عند انتهاء الوقت.",
            flowbuilderAI: "تفعيل مخرج الذكاء الاصطناعي في FlowBuilder",
            flowbuilderAIApiKey: "مفتاح OpenAI API (مخرج الذكاء الاصطناعي)",
            flowbuilderAIApiKeyHelper: "مفتاح OpenAI API المستخدم بواسطة مخرج الذكاء الاصطناعي في كتل FlowBuilder.",
          },
          LGPD: {
            title: "GDPR",
            welcome: "رسالة ترحيب (GDPR)",
            linkLGPD: "رابط سياسة الخصوصية",
            obfuscateMessageDelete: "إخفاء الرسالة المحذوفة من جهة الاتصال",
            alwaysConsent: "طلب الموافقة دائماً من جهة الاتصال",
            obfuscatePhoneUser: "إخفاء رقم الهاتف عن المستخدمين",
            enabled: "مُفعل",
            disabled: "غير مُفعل",
          },
        },
        helps: {
          systemCurrency: {
            description: "يحدد العملة المعروضة في بطاقات Kanban وفي جميع حقول القيمة في النظام.",
            steps: [
              "اختر العملة من القائمة المنسدلة.",
              "يتم مزامنة التغيير في الوقت الفعلي لجميع المستخدمين.",
              "يؤثر على بطاقات Kanban والحملات والتقارير المالية.",
            ],
          },
          userCreation: {
            description: "يسمح للمستخدمين الجدد بالتسجيل في المنصة.",
            steps: [
              "فعّل لإتاحة التسجيل العام في /signup.",
              "عطّل للحفاظ على التحكم الكامل بالوصول.",
            ],
          },
          userRating: {
            description: "يطلب تقييم الخدمة من العميل عند نهاية التذكرة.",
            steps: [
              "فعّل لإرسال استبيان رضا عند إغلاق التذكرة.",
              "يقيّم العميل من 1 إلى 5.",
              "تظهر البيانات في تقارير الجودة.",
            ],
          },
          sendGreetingAccepted: {
            description: "يرسل رسالة للعميل عند قبول التذكرة من قبل الوكيل.",
            steps: [
              "فعّل لبدء المحادثة برسالة ترحيب تلقائية.",
              "خصّص النص في الحقل الذي يظهر أدناه.",
              "يستلمها العميل فور النقر على قبول.",
            ],
          },
          userRandom: {
            description: "يوزّع التذاكر عشوائياً بين الوكلاء المتصلين.",
            steps: [
              "فعّل لتوازن أعباء العمل.",
              "فقط الوكلاء المتصلون يستلمون التوزيع.",
            ],
          },
          sendMsgTransfTicket: {
            description: "يرسل رسالة للعميل عند تحويل التذكرة إلى قائمة أخرى.",
            steps: [
              "فعّل لإبلاغ العميل بالتحويل.",
              "استخدم ${queue.name} لإدراج اسم القائمة الجديدة.",
              "خصّص الرسالة في الحقل أدناه.",
            ],
          },
          acceptCallWhatsapp: {
            description: "يحدد إذا كان واتساب يقبل المكالمات الصوتية/المرئية من العملاء.",
            steps: [
              "عطّل لإرسال رسالة تلقائية عند اتصال العميل.",
              "اضبط الرسالة في الحقل أدناه.",
              "مفيد عندما لا يستقبل فريقك المكالمات.",
            ],
          },
          sendSignMessage: {
            description: "يسمح للوكيل بإرسال توقيعه مع الرسائل.",
            steps: [
              "فعّل لإظهار زر التوقيع في المحادثة.",
              "كل وكيل يضع توقيعه في الملف الشخصي.",
            ],
          },
          sendGreetingMessageOneQueues: {
            description: "يرسل التحية حتى عند تكوين قائمة واحدة فقط.",
            steps: [
              "افتراضياً، تُتخطّى التحية مع قائمة واحدة.",
              "فعّل لإرسال التحية المضبوطة دائماً.",
            ],
          },
          sendQueuePosition: {
            description: "يخبر العميل بمكانه الحالي في قائمة الانتظار.",
            steps: [
              "فعّل لتقديم الشفافية حول وقت الانتظار.",
              "استخدم ${pos} لإدراج المكان في الرسالة.",
              "خصّص النص في الحقل أدناه.",
            ],
          },
          sendFarewellWaitingTicket: {
            description: "يرسل رسالة وداع عندما تظل التذكرة في قائمة الانتظار.",
            steps: [
              "فعّل لإبلاغ العميل بوقت الانتظار.",
              "تُضبط الرسالة في كل قائمة.",
            ],
          },
          acceptAudioMessageContact: {
            description: "يحدد إذا كان النظام يقبل الرسائل الصوتية من العملاء.",
            steps: [
              "عطّل لمنع استلام الرسائل الصوتية.",
              "النص والوسائط الأخرى تستمر بالعمل بشكل طبيعي.",
            ],
          },
          enableLGPD: {
            description: "يفعّل ضوابط حماية البيانات (GDPR).",
            steps: [
              "فعّل لإظهار إشعارات الخصوصية للعميل.",
              "اضبط رسالة الترحيب ورابط السياسة.",
              "استخدم الخيارات أدناه لإخفاء البيانات الحساسة.",
            ],
          },
          requiredTag: {
            description: "يتطلب وجود وسم واحد على الأقل قبل إغلاق التذكرة.",
            steps: [
              "فعّل لضمان تصنيف التذاكر.",
              "لن يستطيع الوكلاء إغلاق التذاكر بدون وسم.",
              "أدر الوسوم من \"الوسوم\" في القائمة الجانبية.",
            ],
          },
          closeTicketOnTransfer: {
            description: "يغلق التذكرة الحالية عند التحويل إلى قسم آخر.",
            steps: [
              "فعّل لإنشاء تذكرة جديدة في القسم الهدف.",
              "يُحفظ السجل في كلا التذكرتين.",
              "مفيد لفصل الخدمة حسب القسم.",
            ],
          },
          showNotificationPending: {
            description: "يعرض إشعاراً مرئياً للتذاكر المعلقة.",
            steps: [
              "فعّل لتنبيه الوكلاء حول التذاكر المنتظرة.",
              "تظهر الإشعارات في الزاوية اليمنى العليا.",
            ],
          },
          autoTranslate: {
            description: "يترجم الرسائل تلقائياً باستخدام الذكاء الاصطناعي.",
            steps: [
              "فعّل والصق مفتاح OpenAI API في الحقل أدناه.",
              "تُترجم الرسائل إلى لغة الوكيل.",
              "تُحسب التكاليف من قبل OpenAI حسب الرموز المستهلكة.",
            ],
          },
          aiAutoSummary: {
            description: "ينتج ملخصات يومية تلقائية للتذاكر باستخدام الذكاء الاصطناعي.",
            steps: [
              "فعّل لاستلام ملخصات يومية لما تم التعامل معه.",
              "حدّد الوقت الذي سيُنتج فيه الملخص.",
              "يغطي جميع التذاكر المفتوحة لذلك اليوم.",
            ],
          },
          sendWelcomeMessage: {
            description: "يرسل رسالة ترحيب عند تسجيل شركة جديدة.",
            steps: [
              "فعّل لأتمتة عملية الإلحاق للعملاء الجدد.",
              "خصّص القالب باستخدام متغيرات مثل {name}, {companyName}.",
              "المتغيرات المتاحة: {email}, {phone}, {trialDate}.",
            ],
          },
          flowbuilderAI: {
            description: "يفعّل \"مخرج الذكاء الاصطناعي\" في كتل FlowBuilder.",
            steps: [
              "فعّل لاستخدام الذكاء الاصطناعي عند انتهاء وقت الرد.",
              "الصق مفتاح OpenAI API في الحقل أدناه.",
              "يقرأ الذكاء الاصطناعي السجل ويتولى المحادثة تلقائياً.",
            ],
          },
          lgpdDeleteMessage: {
            description: "يخفي محتوى الرسائل التي يحذفها جهة الاتصال.",
            steps: [
              "فعّل لإخفاء الرسائل التي حذفها العميل.",
              "عطّل للحفاظ على المحتوى الأصلي ظاهراً.",
              "موصى به لمتطلبات GDPR.",
            ],
          },
          lgpdConsent: {
            description: "يطلب موافقة صريحة من جهة الاتصال على جمع البيانات.",
            steps: [
              "فعّل لإرسال إشعار الموافقة عند أول تواصل.",
              "يجب أن يقبل العميل قبل المتابعة.",
              "مطلوب في التدفقات الحساسة وفقاً لـ GDPR.",
            ],
          },
          lgpdHideNumber: {
            description: "يخفي رقم هاتف جهة الاتصال عن المستخدمين الآخرين.",
            steps: [
              "فعّل لإخفاء الرقم عن الوكلاء غير المخوّلين.",
              "فقط المسؤولون يرون الرقم الكامل.",
              "موصى به لامتثال الخصوصية.",
            ],
          },
        },
        smtp: {
          title: "إعدادات البريد الإلكتروني (SMTP)",
          subtitle: "قم بتكوين خادم SMTP لإرسال رسائل استعادة كلمة المرور والإشعارات.",
          preset: "مزوّد البريد الإلكتروني",
          presetCustom: "مخصص",
          host: "خادم SMTP",
          port: "المنفذ",
          user: "المستخدم / البريد الإلكتروني",
          userPlaceholder: "you@yourdomain.com",
          password: "كلمة المرور",
          from: "بريد المرسل",
          fromHelper: "إذا كان فارغاً، سيتم استخدام اسم مستخدم SMTP",
          fromPlaceholder: "noreply@yourdomain.com",
          secure: "الأمان",
          secureSslOption: "SSL/TLS (المنفذ 465)",
          secureStarttlsOption: "STARTTLS (المنفذ 587)",
          sendgridUserLabel: "المستخدم (ثابت: apikey)",
          sendgridUserHelper: "يستخدم SendGrid كلمة 'apikey' كاسم مستخدم ثابت",
          sendgridPasswordLabel: "مفتاح API",
          sendgridFromHelper: "مطلوب: استخدم مرسلاً موثقاً في SendGrid",
          save: "حفظ الإعدادات",
          testConnection: "اختبار الاتصال",
          sendTestTitle: "إرسال بريد اختبار",
          sendTestSubtitle: "أرسل بريد اختبار للتأكد من عمل إعدادات SMTP بشكل صحيح.",
          testEmailLabel: "بريد المستلم",
          testEmailPlaceholder: "test@email.com",
          sendTest: "إرسال الاختبار",
          fillRequired: "أدخل المضيف واسم المستخدم وكلمة المرور.",
          fillTestEmail: "أدخل بريد المستلم.",
          saveSuccess: "تم حفظ إعدادات SMTP بنجاح!",
          saveError: "خطأ في حفظ إعدادات SMTP.",
          testError: "خطأ في اختبار اتصال SMTP.",
          sendTestError: "خطأ في إرسال بريد الاختبار.",
          helps: {
            serverConfig: {
              description: "يقوم بتكوين خادم SMTP المستخدم لإرسال رسائل النظام (استعادة كلمة المرور، الإشعارات، الدعوات).",
              steps: [
                "اختر مزوداً جاهزاً (Hostinger أو Gmail أو SendGrid أو Outlook) أو \"مخصص\".",
                "املأ المضيف، المنفذ، اسم المستخدم (بريد الحساب) وكلمة المرور (أو كلمة مرور التطبيق).",
                "اختر SSL/TLS (المنفذ 465) أو STARTTLS (المنفذ 587) حسب مزودك.",
                "انقر على \"اختبار الاتصال\" للتحقق قبل الحفظ.",
                "احفظ الإعدادات.",
              ],
            },
            sendTest: {
              description: "يرسل بريد اختبار باستخدام إعدادات SMTP أعلاه للتحقق من سير العمل بالكامل.",
              steps: [
                "احفظ إعدادات SMTP أولاً.",
                "أدخل بريد مستلم صالحاً.",
                "انقر على \"إرسال الاختبار\" — يصل البريد خلال ثوانٍ.",
                "تحقق من صندوق الوارد (ومجلد البريد العشوائي) للتأكد.",
              ],
            },
          },
        },
        meta: {
          copy: "نسخ",
          copied: "تم النسخ!",
          credentials: {
            title: "بيانات اعتماد تطبيق Meta",
            description: "اربط تطبيقك المنشأ على Meta for Developers لدمج Facebook Messenger و Instagram Direct.",
            appIdLabel: "Facebook App ID",
            appIdPlaceholder: "مثال: 123456789012345",
            appIdHelper: "تجده في developers.facebook.com › App › الإعدادات › الأساسية.",
            appSecretLabel: "Facebook App Secret",
            appSecretPlaceholder: "مثال: abc123def456...",
            appSecretHelper: "المفتاح السري للتطبيق. لا تشاركه أو تضعه في المستودع أبداً.",
          },
          webhook: {
            title: "إعدادات Webhook",
            description: "استخدم هذه القيم عند تسجيل الـ webhook في لوحة Meta حتى تصل الرسائل إلى النظام.",
            verifyTokenLabel: "رمز التحقق",
            verifyTokenHelper: "يتم إنشاؤه تلقائياً. الصقه في حقل \"رمز التحقق\" في webhook في Meta.",
            callbackUrlLabel: "عنوان URL لرد الاتصال",
            callbackUrlHelper: "الصقه في حقل \"Callback URL\" في webhook على Meta for Developers.",
          },
          helps: {
            credentials: {
              description: "بيانات الاعتماد من تطبيقك على Meta for Developers — مطلوبة حتى تصل رسائل Messenger و Instagram إلى المنصة.",
              steps: [
                "ادخل إلى developers.facebook.com وأنشئ تطبيقاً من نوع \"أعمال\".",
                "في التطبيق، افتح الإعدادات › الأساسية — انسخ App ID و App Secret.",
                "الصق القيم هنا — يتم الحفظ تلقائياً عند مغادرة الحقل.",
                "أضف منتجَي \"Messenger\" و \"Instagram Graph API\" إلى التطبيق.",
              ],
            },
            webhook: {
              description: "Webhook الذي تستخدمه Meta لإرسال الرسائل من قنواتك إلى النظام.",
              steps: [
                "في تطبيق Meta، افتح Messenger › الإعدادات › Webhooks (نفس الشيء لـ Instagram).",
                "انقر على \"Add Callback URL\".",
                "انسخ Callback URL من هنا والصقه في الحقل المقابل.",
                "انسخ رمز التحقق من هنا والصقه في حقل \"Token\" في Meta.",
                "أكّد — ستقوم Meta بالتحقق من الـ webhook تلقائياً.",
              ],
            },
          },
        },
        timezone: {
          companyTimezone: {
            title: "المنطقة الزمنية للشركة",
            selectLabel: "اختر المنطقة الزمنية",
            customHelperText: "منطقة زمنية مخصصة لهذه الشركة",
            inheritedHelperText: "استخدام المنطقة الزمنية الافتراضية للنظام",
          },
          defaultTimezone: {
            title: "المنطقة الزمنية الافتراضية للنظام",
            selectLabel: "اختر المنطقة الزمنية الافتراضية",
            helperText: "هذه المنطقة الزمنية ستستخدم افتراضياً لجميع الشركات التي لا تملك منطقة زمنية مخصصة",
          },
          buttons: {
            save: "حفظ",
            useDefault: "استخدام الافتراضي",
            saveDefault: "حفظ الافتراضي",
          },
          preview: {
            currentTime: "الوقت الحالي",
            defaultTime: "الوقت الافتراضي",
          },
          status: {
            custom: "مخصص",
            inherited: "موروث",
          },
          errors: {
            fetchAvailableTimezones: "خطأ في تحميل المناطق الزمنية المتاحة",
            fetchCompanyTimezone: "خطأ في تحميل المنطقة الزمنية للشركة",
            updateDefaultTimezone: "خطأ في تحديث المنطقة الزمنية الافتراضية",
            updateCompanyTimezone: "خطأ في تحديث المنطقة الزمنية للشركة",
          },
          success: {
            defaultTimezoneUpdated: "تم تحديث المنطقة الزمنية الافتراضية بنجاح",
            companyTimezoneUpdated: "تم تحديث المنطقة الزمنية للشركة بنجاح",
            companyTimezoneReset: "تم إعادة تعيين المنطقة الزمنية للشركة بنجاح",
          },
          helps: {
            companyTimezone: {
              description: "يحدد المنطقة الزمنية المستخدمة لجميع التواريخ والأوقات في الشركة (الإشعارات، الجداول، التقارير، ساعات العمل).",
              steps: [
                "اختر المنطقة الزمنية المطلوبة من القائمة المنسدلة.",
                "انقر على \"حفظ\" للتطبيق — يؤثر على الشركة بأكملها.",
                "انقر على \"استخدام الافتراضي\" للعودة إلى المنطقة المحددة من قبل المسؤول الأعلى.",
                "تعرض المعاينة على اليمين الوقت الحالي في المنطقة المختارة.",
              ],
            },
            defaultTimezone: {
              description: "المنطقة الزمنية المستخدمة افتراضياً لجميع الشركات التي لم تحدد منطقتها الخاصة.",
              steps: [
                "حدد هنا المنطقة الزمنية الافتراضية للنظام.",
                "الشركات بدون منطقة مخصصة ترث هذه القيمة.",
                "التغييرات هنا تؤثر فقط على الشركات التي لم تخصص منطقتها الخاصة.",
                "فقط المسؤولون الأعلى يمكنهم تغيير هذا الحقل.",
              ],
            },
          },
        },
      },
      validationResponsive: {
        ratingRequired: "التقييم مطلوب"
      }
    },
  },
};

export { messages };
